// import React, { useRef, useState } from "react"
// import { Helmet } from 'react-helmet-async';
// import { Container } from "@mui/material";
// import ReactQuill from 'react-quill';
// import axios from "axios";
// import Swal from 'sweetalert2';
// import { useNavigate } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";

// import { Url, awsFileUrl } from "../url/url";
// import 'react-quill/dist/quill.snow.css';
// import EditorToolbar, { modules, formats } from "../utils/EditorToolbar";
// import "../App.css"
// import { productdata } from "../redux/slice/product";

// const ageGroupOptions = ['0-12 months', '1-2 years', '3+ years', '5+ years', '10+ years'];

// const AddProduct = () => {


//     const navigate = useNavigate()
//     const dispatch = useDispatch()
//     const categoryAllData = useSelector(store => store.category.data)
//     const subcategoryAllData = useSelector(store => store.subcategory.data)
//     const characterAllData = useSelector(store => store.character.data)
//     const subcharacterAllData = useSelector(store => store.subcharacter.data)
//     const [keyvalue, setKeyValue] = useState('');
//     const [specificationvalue, setSpecificationValue] = useState('');
//     const [otherValue, setOtherValue] = useState('');
//     const [descriptionValue, setDescriptionValue] = useState('');
//     const [loading, setLoading] = useState(false)
//     const [formValue, setFormValue] = useState({});

//     const [ageGroupSelectedOptions, setAgeGroupSelectedOptions] = useState([]);
//     const [ageGroupError, setAgeGroupError] = useState(false);
//     const errorRef = useRef(null);


//     const [uploadLoading, setUploadLoading] = useState(false);
//     const [progressValue, setProgressValue] = useState(0);
//     const [uploadStatus, setUploadStatus] = useState(false);

//     const [progressVideoValue, setProgressVideoValue] = useState(0)


//     const [multipleFileProgress, setMultipleFileProgress] = useState(0)
//     const [totalfiles, setTotalFiles] = useState(0)
//     const [totalUpload, setTotalUpload] = useState(0)
//     const [multipleFileStatus, setMultipleFileStatus] = useState(false)

//     const handleAgeGroupChange = (option) => {
//         setAgeGroupSelectedOptions((prev) =>
//             prev.includes(option)
//                 ? prev.filter((item) => item !== option) // Remove if already selected
//                 : [...prev, option] // Add if not selected
//         );
//     };


//     const formHandle = (e) => {
//         const name = e.target.name
//         const value = e.target.value
//         setFormValue({ ...formValue, [name]: value })
//     }
//     const fileHandle = async (e) => {
//         const files = e.target.files;
//         const name = e.target.name;
//         const uploadedFiles = [];
//         setTotalFiles(files?.length);
//         setTotalUpload(0);
//         setMultipleFileProgress(0);
//         setMultipleFileStatus(true);
//         try {
//             await Array.from(files).reduce(async (previousPromise, file, i) => {
//                 await previousPromise;
//                 if (file) {
//                     const response = await axios.post(`${Url}/api/createPresignedUrl/products`, { fileName: file.name, fileType: file.type });
//                     if (response.status === 200) {
//                         const { preSignedUrl, key } = response?.data;
//                         const responseFileSave = await axios.put(preSignedUrl, file, {
//                             onUploadProgress: (progressEvent) => {
//                                 const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                                 setMultipleFileProgress(progress);
//                             },
//                         });

//                         if (responseFileSave.status === 200) {
//                             const fileUrl = `${awsFileUrl}/${key}`;
//                             setTotalUpload(i + 1);
//                             uploadedFiles.push(fileUrl);
//                         } else {
//                             throw new Error('File upload failed');
//                         }
//                     }
//                 }
//             }, Promise.resolve());

//             setFormValue({ ...formValue, [name]: uploadedFiles });
//             setMultipleFileStatus(false);
//             setUploadStatus(true);
//         } catch (error) {
//             console.log(error);
//         } finally {
//             setMultipleFileStatus(false);
//             setProgressValue(0);
//         }
//     };
//     const thumbnailHandle = async (e) => {
//         const file = e.target.files[0]
//         const name = e.target.name
//         setUploadLoading(true)
//         try {
//             if (file) {
//                 const response = await axios.post(`${Url}/api/createPresignedUrl/products`, { fileName: file.name, fileType: file.type })
//                 if (response.status === 200) {
//                     const { preSignedUrl, key } = response?.data
//                     const responseFileSave = await axios.put(preSignedUrl, file, {
//                         onUploadProgress: (progressEvent) => {
//                             const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                             setProgressValue(progress)
//                         },
//                     })
//                     if (responseFileSave.status === 200) {
//                         const fileUrl = `${awsFileUrl}/${key}`
//                         setFormValue({ ...formValue, [name]: fileUrl })
//                         setUploadStatus(true)
//                         setUploadLoading(false)
//                         setProgressValue(0)
//                     }
//                     else {
//                         setUploadLoading(false)
//                         setProgressValue(0)
//                         setUploadStatus(false)
//                     }
//                     setUploadLoading(false)
//                 }
//                 setUploadLoading(false)
//             }
//         } catch (error) {
//             console.log(error);
//             setUploadLoading(false)
//         }
//         setUploadLoading(false)
//     }
//     const videoHandle = async (e) => {
//         const file = e.target.files[0]
//         const name = e.target.name
//         try {
//             if (file) {
//                 const response = await axios.post(`${Url}/api/createPresignedUrl/products/video`, { fileName: file.name, fileType: file.type })
//                 if (response.status === 200) {
//                     const { preSignedUrl, key } = response?.data
//                     const responseFileSave = await axios.put(preSignedUrl, file, {
//                         onUploadProgress: (progressEvent) => {
//                             const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                             setProgressVideoValue(progress)
//                         },
//                     })
//                     if (responseFileSave.status === 200) {
//                         const fileUrl = `${awsFileUrl}/${key}`
//                         setFormValue({ ...formValue, [name]: fileUrl })
//                         console.log("fileUrl", fileUrl);

//                         // setProgressVideoValue(100)
//                     }
//                     // setProgressVideoValue(100)
//                 }
//             }
//         } catch (error) {
//             console.log(error);
//         }
//     }
//     const submit = async (e) => {
//         e.preventDefault()
//         setLoading(true)
//         setAgeGroupError(false);
//         if (ageGroupSelectedOptions.length === 0) {
//             setAgeGroupError(true);
//             errorRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
//             return;
//         }
//         if (descriptionValue) {
//             const dataValue = { ...formValue, "description": descriptionValue, "specification": specificationvalue, "keyFeature": keyvalue, "otherInfo": otherValue, ageGroup: ageGroupSelectedOptions }
//             try {
//                 await axios.post(`${Url}/product/add`, dataValue).then((data) => {
//                     Swal.fire({
//                         position: 'top-end',
//                         icon: 'success',
//                         title: 'Add Product Success',
//                         showConfirmButton: false,
//                         timer: 1500
//                     })
//                     setLoading(false)
//                     dispatch(productdata())
//                     navigate("/dashboard/products")
//                 })
//             } catch (error) {
//                 Swal.fire({
//                     position: 'top-end',
//                     icon: 'error',
//                     title: "Something Went Wrong",
//                     showConfirmButton: false,
//                     timer: 1500
//                 })
//                 console.log(error.message);
//                 setLoading(false)
//             }
//         }
//         else {
//             setLoading(false)
//             console.log("all fields are required ");
//             Swal.fire('All fields are required')
//         }

//     }


//     return (
//         <>
//             <Helmet>
//                 <title> Dashboard: Blog </title>
//             </Helmet>


//             <Container>
//                 <div className="mb-4 text-primary">
//                     <h2 className="text-capitalize">Add new product</h2>
//                 </div>
//                 <div className="p-3 bg-light rounded shadow border">
//                     <form action="" onSubmit={e => submit(e)}>
//                         <div className="row">
//                             <div className="col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Product Name</p>
//                                     <input type="text" name="productName" value={formValue.productName} onChange={e => formHandle(e)} className="form-control" required />
//                                 </div>
//                             </div>
//                             <div className="col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">short Description</p>
//                                     <textarea className="form-control" name="shortDescription" value={formValue.shortDescription} onChange={e => formHandle(e)} rows="3" required />
//                                 </div>
//                             </div>
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Image Alt Tag</p>
//                                     <input type="text" name="altTag" value={formValue.altTag} onChange={e => formHandle(e)} className="form-control" required />
//                                 </div>
//                             </div>

//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Thumbnail Image</p>
//                                     <input type="file" name="thumbnailImage" onChange={e => thumbnailHandle(e)} accept="image/*" className="form-control" required />

//                                     <div className="d-flex justify-content-end gap-2 pt-2">
//                                         {uploadLoading && progressValue && <progress className="flex-grow-1" value={progressValue} max="100" style={{ height: "5px" }} />}

//                                         {uploadStatus && <small className="fs-10 text-success">{uploadLoading ? `${progressValue} %` : 'success'} </small>}

//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Images</p>
//                                     <input type="file" name="images" multiple onChange={e => fileHandle(e)} className="form-control" required accept="image/*" />
//                                     {multipleFileStatus && <progress className=" w-100" value={multipleFileProgress} max="100" style={{ height: "5px" }} />}
//                                     {totalfiles !== 0 &&
//                                         <div className="d-flex justify-content-end gap-2 pt-2 align-items-center">
//                                             <progress className="flex-grow-1 " value={(totalUpload / totalfiles) * 100} max="100" style={{ height: "5px" }} />

//                                             <small className="fs-10 text-secondary w-max-content">{totalUpload}/{totalfiles}  </small>
//                                             <small className="fs-10 text-success w-max-content">{((totalUpload / totalfiles) * 100).toFixed(1)} % </small>

//                                         </div>}
//                                 </div>
//                             </div>
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Product Video <span className="fw-normal text-secondary"> (optional) </span></p>
//                                     <input type="file" name="video" accept="video/*" onChange={e => videoHandle(e)} className="form-control" />

//                                     <div className="d-flex justify-content-end gap-2 pt-2">
//                                         {progressVideoValue > 0 && progressVideoValue < 100 && <progress className="flex-grow-1" value={progressVideoValue} max="100" style={{ height: "5px" }} />}

//                                         {progressVideoValue > 0 && <small className="fs-10 text-success">{progressVideoValue < 100 ? `${progressVideoValue} %` : 'success'} </small>}

//                                     </div>
//                                 </div>
//                             </div>


//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">MRP (<i className="fa-solid fa-indian-rupee-sign text-muted fa-sm" />)</p>
//                                     <input type="number" name="mrp" value={formValue.mrp} onChange={e => formHandle(e)} className="form-control" required onWheel={(e) => e.target.blur()} />
//                                 </div>
//                             </div>
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Sale Price (<i className="fa-solid fa-indian-rupee-sign text-muted fa-sm" />)</p>
//                                     <input type="number" name="salePrice" value={formValue.salePrice} onChange={e => formHandle(e)} className="form-control" required onWheel={(e) => e.target.blur()} />
//                                 </div>
//                             </div>
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Discount (%) </p>
//                                     <input type="number" name="discount" value={formValue.discount} onChange={e => formHandle(e)} className="form-control" required onWheel={(e) => e.target.blur()} />
//                                 </div>
//                             </div>
//                             <div className="col-lg-6 col-12">
//                                 <div className="row">
//                                     <div className="col-lg-3 col-md-6 mb-2">
//                                         <div className="form-group">
//                                             <p className="mb-0 fw-bold">Height</p>
//                                             <input type="height" name="height" value={formValue.height} onChange={e => formHandle(e)} className="form-control" required />
//                                         </div>
//                                     </div>
//                                     <div className="col-lg-3 col-md-6 mb-2">
//                                         <div className="form-group">
//                                             <p className="mb-0 fw-bold">Width</p>
//                                             <input type="width" name="width" value={formValue.width} onChange={e => formHandle(e)} className="form-control" required />
//                                         </div>
//                                     </div>
//                                     <div className="col-lg-3 col-md-6 mb-2">
//                                         <div className="form-group">
//                                             <p className="mb-0 fw-bold">Depth</p>
//                                             <input type="depth" name="depth" value={formValue.depth} onChange={e => formHandle(e)} className="form-control" required />
//                                         </div>
//                                     </div>
//                                     <div className="col-lg-3 col-md-6 mb-2">
//                                         <div className="form-group">
//                                             <p className="mb-0 fw-bold">size</p>
//                                             <select name="measurement" value={formValue.measurement} onChange={e => formHandle(e)} className="form-select" required>
//                                                 <option value='' disabled={(formValue.measurement)} >Choose</option>
//                                                 <option value={"cm"} >cm</option>
//                                                 {/* <option value={"inch"} >inch</option> */}
//                                             </select>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Total Product</p>
//                                     <input type="number" name="totalProduct" value={formValue.totalProduct} onChange={e => formHandle(e)} className="form-control" required onWheel={(e) => e.target.blur()} />
//                                 </div>
//                             </div>
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Category</p>
//                                     <select name="category" value={formValue.category} onChange={e => formHandle(e)} className="form-select" required>
//                                         <option value='' disabled={(formValue.category)}>Category Choose</option>
//                                         {categoryAllData.map((cv, i) => {
//                                             return (
//                                                 <option value={cv.category} key={i}>{cv.category}</option>
//                                             )
//                                         })}
//                                     </select>
//                                 </div>
//                             </div>
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Sub Category</p>
//                                     <select name="subcategory" value={formValue.subcategory} onChange={e => formHandle(e)} className="form-select" required>
//                                         <option value='' disabled={(formValue.subcategory)} > Choose</option>
//                                         {formValue.category && subcategoryAllData.filter(val => val.category === formValue.category).map((value, i) => {
//                                             return (
//                                                 <option value={value.subcategory} key={i}>{value.subcategory}</option>
//                                             )
//                                         })}
//                                     </select>
//                                 </div>
//                             </div>

//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Character</p>
//                                     <select name="character" value={formValue.character} onChange={e => formHandle(e)} id="" className="form-select" required>
//                                         <option value='' disabled={(formValue.character)} >Character Choose</option>
//                                         {characterAllData.map((cv, i) => {
//                                             return (
//                                                 <option value={cv.character} key={i}>{cv.character}</option>
//                                             )
//                                         })}
//                                     </select>
//                                 </div>
//                             </div>
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Sub Character</p>
//                                     <select name="subcharacter" value={formValue.subcharacter} onChange={e => formHandle(e)} className="form-select" required>
//                                         <option disabled={(formValue.subcharacter)} value='' > Choose</option>
//                                         {formValue.character && subcharacterAllData.filter(val => val.character === formValue.character).map((value, i) => {
//                                             return (
//                                                 <option value={value.subcharacter} key={i}>{value.subcharacter}</option>
//                                             )
//                                         })}
//                                     </select>
//                                 </div>
//                             </div>

//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Batch No.</p>
//                                     <input type="text" name="batch" value={formValue.batch} onChange={e => formHandle(e)} className="form-control" required />
//                                 </div>
//                             </div>
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">SKU No.</p>
//                                     <input type="text" name="sku" value={formValue.sku} onChange={e => formHandle(e)} className="form-control" required />
//                                 </div>
//                             </div>
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Replacement (days)</p>
//                                     <input type="number" name="replacement" value={formValue.replacement} onChange={e => formHandle(e)} className="form-control" required onWheel={(e) => e.target.blur()} />
//                                 </div>
//                             </div>


//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Product Weight (gm)</p>
//                                     <input type="number" name="weight" value={formValue.weight} onChange={e => formHandle(e)} className="form-control" required onWheel={(e) => e.target.blur()} />
//                                 </div>
//                             </div>
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Choose Tags <span className="fw-normal text-secondary"> (optional) </span> </p>
//                                     <select name="tags" value={formValue.tags ? formValue.tags : ""} onChange={e => formHandle(e)} className="form-select" >
//                                         <option value="">Choose Any Tag</option>
//                                         <option value="top picks">Top Picks</option>
//                                         <option value="new arrival">New Arrival</option>
//                                     </select>
//                                 </div>
//                             </div>
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <p className="mb-0 fw-bold">Choose Product Age Group</p>
//                                 {ageGroupError && (
//                                     <p ref={errorRef} className="text-danger fw-normal mb-1">
//                                         Please select at least one option!
//                                     </p>
//                                 )}
//                                 {ageGroupOptions.map((option, index) => (
//                                     <div key={index} className="form-check">
//                                         <input
//                                             type="checkbox"
//                                             id={option}
//                                             checked={ageGroupSelectedOptions.includes(option)}
//                                             onChange={() => handleAgeGroupChange(option)}
//                                             className="form-check-input"
//                                         />
//                                         <label htmlFor={option} className="form-check-label">
//                                             {option}
//                                         </label>
//                                     </div>
//                                 ))}
//                             </div>






//                             <div className="col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Product Description</p>
//                                     <div className="text-editor bg-white rounded">
//                                         <ReactQuill theme="snow" value={descriptionValue} onChange={setDescriptionValue} placeholder={"Write something awesome..."} />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Material</p>
//                                     <div className="text-editor bg-white">
//                                         <EditorToolbar />
//                                         <ReactQuill theme="snow" value={keyvalue} onChange={setKeyValue} placeholder={"Write something awesome..."} modules={modules} formats={formats} />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Dimensions</p>
//                                     <div className="text-editor bg-white">
//                                         <ReactQuill theme="snow" value={specificationvalue} onChange={setSpecificationValue} placeholder={"Write something awesome..."} />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Care Instructions</p>
//                                     <div className="text-editor bg-white">
//                                         <ReactQuill theme="snow" name="other_info" value={otherValue} onChange={setOtherValue} placeholder={"Write something awesome..."} />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-12 ">
//                                 <div className="form-group text-end">
//                                     <button className="btn btn-primary" type="submit" disabled={loading}  >
//                                         {loading ? "Saving..." : "Post"}
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     </form>
//                 </div>
//             </Container>
//         </>
//     )
// }

// export default AddProduct







// import React, { useRef, useState } from "react"
// import { Helmet } from 'react-helmet-async';
// import { Container } from "@mui/material";
// import ReactQuill from 'react-quill';
// import axios from "axios";
// import Swal from 'sweetalert2';
// import { useNavigate } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";

// import { Url, awsFileUrl } from "../url/url";
// import 'react-quill/dist/quill.snow.css';
// import EditorToolbar, { modules, formats } from "../utils/EditorToolbar";
// import "../App.css"
// import { productdata } from "../redux/slice/product";

// const ageGroupOptions = ['0-12 months', '1-2 years', '3+ years', '5+ years', '10+ years'];

// const AddProduct = () => {
//     const navigate = useNavigate()
//     const dispatch = useDispatch()
//     const categoryAllData = useSelector(store => store.category.data)
//     const subcategoryAllData = useSelector(store => store.subcategory.data)
//     const characterAllData = useSelector(store => store.character.data)
//     const subcharacterAllData = useSelector(store => store.subcharacter.data)
    
//     const [keyvalue, setKeyValue] = useState('');
//     const [specificationvalue, setSpecificationValue] = useState('');
//     const [otherValue, setOtherValue] = useState('');
//     const [descriptionValue, setDescriptionValue] = useState('');
//     const [loading, setLoading] = useState(false)
//     const [formValue, setFormValue] = useState({});
//     const [isLimitedEdition, setIsLimitedEdition] = useState(false);

//     const [ageGroupSelectedOptions, setAgeGroupSelectedOptions] = useState([]);
//     const [ageGroupError, setAgeGroupError] = useState(false);
//     const errorRef = useRef(null);

//     const [uploadLoading, setUploadLoading] = useState(false);
//     const [progressValue, setProgressValue] = useState(0);
//     const [uploadStatus, setUploadStatus] = useState(false);

//     const [progressVideoValue, setProgressVideoValue] = useState(0)

//     const [multipleFileProgress, setMultipleFileProgress] = useState(0)
//     const [totalfiles, setTotalFiles] = useState(0)
//     const [totalUpload, setTotalUpload] = useState(0)
//     const [multipleFileStatus, setMultipleFileStatus] = useState(false)

//     const handleAgeGroupChange = (option) => {
//         setAgeGroupSelectedOptions((prev) =>
//             prev.includes(option)
//                 ? prev.filter((item) => item !== option)
//                 : [...prev, option]
//         );
//     };

//     const formHandle = (e) => {
//         const name = e.target.name
//         const value = e.target.value
//         setFormValue({ ...formValue, [name]: value })
//     }

//     const fileHandle = async (e) => {
//         const files = e.target.files;
//         const name = e.target.name;
//         const uploadedFiles = [];
//         setTotalFiles(files?.length);
//         setTotalUpload(0);
//         setMultipleFileProgress(0);
//         setMultipleFileStatus(true);
        
//         try {
//             await Array.from(files).reduce(async (previousPromise, file, i) => {
//                 await previousPromise;
//                 if (file) {
//                     const response = await axios.post(`${Url}/api/createPresignedUrl/products`, { 
//                         fileName: file.name, 
//                         fileType: file.type 
//                     });
                    
//                     if (response.status === 200) {
//                         const { preSignedUrl, key } = response?.data;
//                         const responseFileSave = await axios.put(preSignedUrl, file, {
//                             onUploadProgress: (progressEvent) => {
//                                 const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                                 setMultipleFileProgress(progress);
//                             },
//                         });

//                         if (responseFileSave.status === 200) {
//                             const fileUrl = `${awsFileUrl}/${key}`;
//                             setTotalUpload(i + 1);
//                             uploadedFiles.push(fileUrl);
//                         } else {
//                             throw new Error('File upload failed');
//                         }
//                     }
//                 }
//             }, Promise.resolve());

//             setFormValue({ ...formValue, [name]: uploadedFiles });
//             setMultipleFileStatus(false);
//             setUploadStatus(true);
//         } catch (error) {
//             console.log(error);
//         } finally {
//             setMultipleFileStatus(false);
//             setProgressValue(0);
//         }
//     };

//     const thumbnailHandle = async (e) => {
//         const file = e.target.files[0]
//         const name = e.target.name
//         setUploadLoading(true)
        
//         try {
//             if (file) {
//                 const response = await axios.post(`${Url}/api/createPresignedUrl/products`, { 
//                     fileName: file.name, 
//                     fileType: file.type 
//                 })
                
//                 if (response.status === 200) {
//                     const { preSignedUrl, key } = response?.data
//                     const responseFileSave = await axios.put(preSignedUrl, file, {
//                         onUploadProgress: (progressEvent) => {
//                             const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                             setProgressValue(progress)
//                         },
//                     })
                    
//                     if (responseFileSave.status === 200) {
//                         const fileUrl = `${awsFileUrl}/${key}`
//                         setFormValue({ ...formValue, [name]: fileUrl })
//                         setUploadStatus(true)
//                         setUploadLoading(false)
//                         setProgressValue(0)
//                     } else {
//                         setUploadLoading(false)
//                         setProgressValue(0)
//                         setUploadStatus(false)
//                     }
//                     setUploadLoading(false)
//                 }
//                 setUploadLoading(false)
//             }
//         } catch (error) {
//             console.log(error);
//             setUploadLoading(false)
//         }
//         setUploadLoading(false)
//     }

//     const videoHandle = async (e) => {
//         const file = e.target.files[0]
//         const name = e.target.name
        
//         try {
//             if (file) {
//                 const response = await axios.post(`${Url}/api/createPresignedUrl/products/video`, { 
//                     fileName: file.name, 
//                     fileType: file.type 
//                 })
                
//                 if (response.status === 200) {
//                     const { preSignedUrl, key } = response?.data
//                     const responseFileSave = await axios.put(preSignedUrl, file, {
//                         onUploadProgress: (progressEvent) => {
//                             const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                             setProgressVideoValue(progress)
//                         },
//                     })
                    
//                     if (responseFileSave.status === 200) {
//                         const fileUrl = `${awsFileUrl}/${key}`
//                         setFormValue({ ...formValue, [name]: fileUrl })
//                         console.log("Video uploaded:", fileUrl);
//                     }
//                 }
//             }
//         } catch (error) {
//             console.log(error);
//         }
//     }

//     // const submit = async (e) => {
//     //     e.preventDefault();
//     //     setLoading(true);
//     //     setAgeGroupError(false);

//     //     // Validate age group
//     //     if (ageGroupSelectedOptions.length === 0) {
//     //         setAgeGroupError(true);
//     //         errorRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
//     //         setLoading(false);
//     //         return;
//     //     }

//     //     // Validate description
//     //     if (!descriptionValue) {
//     //         Swal.fire("All fields are required");
//     //         setLoading(false);
//     //         return;
//     //     }

//     //     // 🔥 PREPARE DATA FOR BACKEND
//     //     const dataValue = {
//     //         ...formValue,
//     //         description: descriptionValue,
//     //         specification: specificationvalue,
//     //         keyFeature: keyvalue,
//     //         otherInfo: otherValue,
//     //         ageGroup: ageGroupSelectedOptions,
//     //         limitedEdition: isLimitedEdition
//     //     };

//     //     console.log("📤 SENDING DATA TO BACKEND:");
//     //     console.log("   Seller Name:", dataValue.sellerName);
//     //     console.log("   Limited Edition:", dataValue.limitedEdition);
//     //     console.log("   Full Data:", dataValue);

//     //     try {
//     //         const res = await axios.post(`${Url}/product/add`, dataValue, {
//     //             headers: {
//     //                 'Content-Type': 'application/json'
//     //             }
//     //         });

//     //         console.log("✅ RESPONSE:", res.data);

//     //         Swal.fire({
//     //             position: "top-end",
//     //             icon: "success",
//     //             title: "Product Added Successfully",
//     //             showConfirmButton: false,
//     //             timer: 1500
//     //         });

//     //         dispatch(productdata());
//     //         navigate("/dashboard/products");

//     //     } catch (error) {
//     //         console.error("❌ ADD PRODUCT ERROR:", error);
//     //         console.error("   Error Response:", error?.response?.data);

//     //         Swal.fire({
//     //             position: "top-end",
//     //             icon: "error",
//     //             title: error?.response?.data?.message || "Something Went Wrong",
//     //             showConfirmButton: false,
//     //             timer: 1500
//     //         });
//     //     } finally {
//     //         setLoading(false);
//     //     }
//     // };
// const submit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setAgeGroupError(false);

//     // Validate age group
//     if (ageGroupSelectedOptions.length === 0) {
//         setAgeGroupError(true);
//         errorRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
//         setLoading(false);
//         return;
//     }

//     // ⭐ Update validation - add otherValue check
//     if (!descriptionValue || !otherValue) {
//         Swal.fire("Description and Care Instructions are required!");
//         setLoading(false);
//         return;
//     }

//     // ⭐ Check if type is selected
//     if (!formValue.type) {
//         Swal.fire("Please select Product Type!");
//         setLoading(false);
//         return;
//     }

//     // ⭐ Check if subcategory is selected
//  // ⭐ Check if subcategory is selected
// if (!formValue.subcategory) {  // Change from subcategory to subcategory
//     Swal.fire("Please select Sub Category!");
//     setLoading(false);
//     return;
// }

//     // PREPARE DATA FOR BACKEND
//     const dataValue = {
//         ...formValue,
//         description: descriptionValue,
//         specification: specificationvalue,
//         keyFeature: keyvalue,
//         otherInfo: otherValue,
//         ageGroup: ageGroupSelectedOptions,
//         limitedEdition: isLimitedEdition
//     };

//     console.log("📤 SENDING DATA TO BACKEND:");
//     console.log("   Type:", dataValue.type); // ⭐ Add this
//     console.log("   subcategory:", dataValue.subcategory); // ⭐ Add this
//     console.log("   Other Info:", dataValue.otherInfo); // ⭐ Add this
//     console.log("   Full Data:", dataValue);

//     try {
//         const res = await axios.post(`${Url}/product/add`, dataValue, {
//             headers: {
//                 'Content-Type': 'application/json'
//             }
//         });

//         console.log("✅ RESPONSE:", res.data);

//         Swal.fire({
//             position: "top-end",
//             icon: "success",
//             title: "Product Added Successfully",
//             showConfirmButton: false,
//             timer: 1500
//         });

//         dispatch(productdata());
//         navigate("/dashboard/products");

//     } catch (error) {
//         console.error("❌ ADD PRODUCT ERROR:", error);
//         console.error("   Error Response:", error?.response?.data);

//         Swal.fire({
//             position: "top-end",
//             icon: "error",
//             title: error?.response?.data?.message || "Something Went Wrong",
//             showConfirmButton: false,
//             timer: 1500
//         });
//     } finally {
//         setLoading(false);
//     }
// };
//     return (
//         <>
//             <Helmet>
//                 <title> Dashboard: Add Product </title>
//             </Helmet>

//             <Container>
//                 <div className="mb-4 text-primary">
//                     <h2 className="text-capitalize">Add new product</h2>
//                 </div>
//                 <div className="p-3 bg-light rounded shadow border">
//                     <form action="" onSubmit={e => submit(e)}>
//                         <div className="row">
//                             <div className="col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Product Name</p>
//                                     <input 
//                                         type="text" 
//                                         name="productName" 
//                                         value={formValue.productName || ""} 
//                                         onChange={e => formHandle(e)} 
//                                         className="form-control" 
//                                         required 
//                                     />
//                                 </div>
//                             </div>

//                             {/* <div className="col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Seller Name</p>
//                                     <input
//                                         type="text"
//                                         name="sellerName"
//                                         value={formValue.sellerName || ""}
//                                         onChange={e => formHandle(e)}
//                                         className="form-control"
//                                         required
//                                     />
//                                 </div>
//                             </div> */}


//    <div className="col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Seller Name</p>
//                                     <select
//                                         name="sellerName"
//                                         value={formValue.sellerName || ""}
//                                         onChange={e => formHandle(e)}
//                                         className="form-select"
//                                         required
//                                     >
//                                         <option value="" disabled>Choose Seller</option>
//                                         <option value="Devi Shera">Devi Shera</option>
//                                         <option value="Doozie-do">Doozie-do</option>
//                                     </select>
//                                 </div>
//                             </div>


//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Limited Edition</p>
//                                     <div className="form-check mt-1">
//                                         <input
//                                             type="checkbox"
//                                             className="form-check-input"
//                                             id="limitedEdition"
//                                             checked={isLimitedEdition}
//                                             onChange={(e) => setIsLimitedEdition(e.target.checked)}
//                                         />
//                                         <span className="form-check-label ms-2">
//                                             Mark as Limited Edition
//                                         </span>
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className="col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Short Description</p>
//                                     <textarea 
//                                         className="form-control" 
//                                         name="shortDescription" 
//                                         value={formValue.shortDescription || ""} 
//                                         onChange={e => formHandle(e)} 
//                                         rows="3" 
//                                         required 
//                                     />
//                                 </div>
//                             </div>

//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Image Alt Tag</p>
//                                     <input 
//                                         type="text" 
//                                         name="altTag" 
//                                         value={formValue.altTag || ""} 
//                                         onChange={e => formHandle(e)} 
//                                         className="form-control" 
//                                         required 
//                                     />
//                                 </div>
//                             </div>

//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Thumbnail Image</p>
//                                     <input 
//                                         type="file" 
//                                         name="thumbnailImage" 
//                                         onChange={e => thumbnailHandle(e)} 
//                                         accept="image/*" 
//                                         className="form-control" 
//                                         required 
//                                     />
//                                     <div className="d-flex justify-content-end gap-2 pt-2">
//                                         {uploadLoading && progressValue && (
//                                             <progress 
//                                                 className="flex-grow-1" 
//                                                 value={progressValue} 
//                                                 max="100" 
//                                                 style={{ height: "5px" }} 
//                                             />
//                                         )}
//                                         {uploadStatus && (
//                                             <small className="fs-10 text-success">
//                                                 {uploadLoading ? `${progressValue}%` : 'success'}
//                                             </small>
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Images</p>
//                                     <input 
//                                         type="file" 
//                                         name="images" 
//                                         multiple 
//                                         onChange={e => fileHandle(e)} 
//                                         className="form-control" 
//                                         required 
//                                         accept="image/*" 
//                                     />
//                                     {multipleFileStatus && (
//                                         <progress 
//                                             className="w-100" 
//                                             value={multipleFileProgress} 
//                                             max="100" 
//                                             style={{ height: "5px" }} 
//                                         />
//                                     )}
//                                     {totalfiles !== 0 && (
//                                         <div className="d-flex justify-content-end gap-2 pt-2 align-items-center">
//                                             <progress 
//                                                 className="flex-grow-1" 
//                                                 value={(totalUpload / totalfiles) * 100} 
//                                                 max="100" 
//                                                 style={{ height: "5px" }} 
//                                             />
//                                             <small className="fs-10 text-secondary w-max-content">
//                                                 {totalUpload}/{totalfiles}
//                                             </small>
//                                             <small className="fs-10 text-success w-max-content">
//                                                 {((totalUpload / totalfiles) * 100).toFixed(1)}%
//                                             </small>
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>

//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">
//                                         Product Video <span className="fw-normal text-secondary">(optional)</span>
//                                     </p>
//                                     <input 
//                                         type="file" 
//                                         name="video" 
//                                         accept="video/*" 
//                                         onChange={e => videoHandle(e)} 
//                                         className="form-control" 
//                                     />
//                                     <div className="d-flex justify-content-end gap-2 pt-2">
//                                         {progressVideoValue > 0 && progressVideoValue < 100 && (
//                                             <progress 
//                                                 className="flex-grow-1" 
//                                                 value={progressVideoValue} 
//                                                 max="100" 
//                                                 style={{ height: "5px" }} 
//                                             />
//                                         )}
//                                         {progressVideoValue > 0 && (
//                                             <small className="fs-10 text-success">
//                                                 {progressVideoValue < 100 ? `${progressVideoValue}%` : 'success'}
//                                             </small>
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">MRP (<i className="fa-solid fa-indian-rupee-sign text-muted fa-sm" />)</p>
//                                     <input 
//                                         type="number" 
//                                         name="mrp" 
//                                         value={formValue.mrp || ""} 
//                                         onChange={e => formHandle(e)} 
//                                         className="form-control" 
//                                         required 
//                                         onWheel={(e) => e.target.blur()} 
//                                     />
//                                 </div>
//                             </div>

//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Sale Price (<i className="fa-solid fa-indian-rupee-sign text-muted fa-sm" />)</p>
//                                     <input 
//                                         type="number" 
//                                         name="salePrice" 
//                                         value={formValue.salePrice || ""} 
//                                         onChange={e => formHandle(e)} 
//                                         className="form-control" 
//                                         required 
//                                         onWheel={(e) => e.target.blur()} 
//                                     />
//                                 </div>
//                             </div>

//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Discount (%)</p>
//                                     <input 
//                                         type="number" 
//                                         name="discount" 
//                                         value={formValue.discount || ""} 
//                                         onChange={e => formHandle(e)} 
//                                         className="form-control" 
//                                         required 
//                                         onWheel={(e) => e.target.blur()} 
//                                     />
//                                 </div>
//                             </div>

//                             <div className="col-lg-6 col-12">
//                                 <div className="row">
//                                     <div className="col-lg-3 col-md-6 mb-2">
//                                         <div className="form-group">
//                                             <p className="mb-0 fw-bold">Height</p>
//                                             <input 
//                                                 type="text" 
//                                                 name="height" 
//                                                 value={formValue.height || ""} 
//                                                 onChange={e => formHandle(e)} 
//                                                 className="form-control" 
//                                                 required 
//                                             />
//                                         </div>
//                                     </div>
//                                     <div className="col-lg-3 col-md-6 mb-2">
//                                         <div className="form-group">
//                                             <p className="mb-0 fw-bold">Width</p>
//                                             <input 
//                                                 type="text" 
//                                                 name="width" 
//                                                 value={formValue.width || ""} 
//                                                 onChange={e => formHandle(e)} 
//                                                 className="form-control" 
//                                                 required 
//                                             />
//                                         </div>
//                                     </div>
//                                     <div className="col-lg-3 col-md-6 mb-2">
//                                         <div className="form-group">
//                                             <p className="mb-0 fw-bold">Depth</p>
//                                             <input 
//                                                 type="text" 
//                                                 name="depth" 
//                                                 value={formValue.depth || ""} 
//                                                 onChange={e => formHandle(e)} 
//                                                 className="form-control" 
//                                                 required 
//                                             />
//                                         </div>
//                                     </div>
//                                     <div className="col-lg-3 col-md-6 mb-2">
//                                         <div className="form-group">
//                                             <p className="mb-0 fw-bold">Unit</p>
//                                             <select 
//                                                 name="measurement" 
//                                                 value={formValue.measurement || ""} 
//                                                 onChange={e => formHandle(e)} 
//                                                 className="form-select" 
//                                                 required
//                                             >
//                                                 <option value='' disabled>Choose</option>
//                                                 <option value="cm">cm</option>
//                                             </select>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Total Product</p>
//                                     <input 
//                                         type="number" 
//                                         name="totalProduct" 
//                                         value={formValue.totalProduct || ""} 
//                                         onChange={e => formHandle(e)} 
//                                         className="form-control" 
//                                         required 
//                                         onWheel={(e) => e.target.blur()} 
//                                     />
//                                 </div>
//                             </div>

//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Category</p>
//                                     <select 
//                                         name="category" 
//                                         value={formValue.category || ""} 
//                                         onChange={e => formHandle(e)} 
//                                         className="form-select" 
//                                         required
//                                     >
//                                         <option value='' disabled>Category Choose</option>
//                                         {categoryAllData.map((cv, i) => (
//                                             <option value={cv.category} key={i}>{cv.category}</option>
//                                         ))}
//                                     </select>
//                                 </div>
//                             </div>

//                      <div className="col-lg-6 col-12 mb-2">
//     <div className="form-group">
//         <p className="mb-0 fw-bold">Sub Category</p>
//         <select 
//             name="subcategory"  // ⭐ Change from "subcategory" to "subcategory"
//             value={formValue.subcategory || ""} 
//             onChange={e => formHandle(e)} 
//             className="form-select" 
//             required
//         >
//             <option value='' disabled>Choose</option>
//             {formValue.category && subcategoryAllData
//                 .filter(val => val.category === formValue.category)
//                 .map((value, i) => (
//                     <option value={value.subcategory} key={i}>
//                         {value.subcategory}
//                     </option>
//                 ))
//             }
//         </select>
//     </div>
// </div>

//                             {/* Category aur subcategory ke baad add karo */}

// <div className="col-lg-6 col-12 mb-2">
//     <div className="form-group">
//         <p className="mb-0 fw-bold">Type</p>
//         <select 
//             name="type" 
//             value={formValue.type || ""} 
//             onChange={e => formHandle(e)} 
//             className="form-select" 
//             required
//         >
//             <option value='' disabled>Choose Type</option>
//             <option value="big">Big</option>
//             <option value="small">Small</option>
//         </select>
//     </div>
// </div>

//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Character</p>
//                                     <select 
//                                         name="character" 
//                                         value={formValue.character || ""} 
//                                         onChange={e => formHandle(e)} 
//                                         className="form-select" 
//                                         required
//                                     >
//                                         <option value='' disabled>Character Choose</option>
//                                         {characterAllData.map((cv, i) => (
//                                             <option value={cv.character} key={i}>{cv.character}</option>
//                                         ))}
//                                     </select>
//                                 </div>
//                             </div>

//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Sub Character</p>
//                                     <select 
//                                         name="subcharacter" 
//                                         value={formValue.subcharacter || ""} 
//                                         onChange={e => formHandle(e)} 
//                                         className="form-select" 
//                                         required
//                                     >
//                                         <option value='' disabled>Choose</option>
//                                         {formValue.character && subcharacterAllData
//                                             .filter(val => val.character === formValue.character)
//                                             .map((value, i) => (
//                                                 <option value={value.subcharacter} key={i}>
//                                                     {value.subcharacter}
//                                                 </option>
//                                             ))
//                                         }
//                                     </select>
//                                 </div>
//                             </div>

//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Batch No.</p>
//                                     <input 
//                                         type="text" 
//                                         name="batch" 
//                                         value={formValue.batch || ""} 
//                                         onChange={e => formHandle(e)} 
//                                         className="form-control" 
//                                         required 
//                                     />
//                                 </div>
//                             </div>

//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">SKU No.</p>
//                                     <input 
//                                         type="text" 
//                                         name="sku" 
//                                         value={formValue.sku || ""} 
//                                         onChange={e => formHandle(e)} 
//                                         className="form-control" 
//                                         required 
//                                     />
//                                 </div>
//                             </div>

//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Replacement (days)</p>
//                                     <input 
//                                         type="number" 
//                                         name="replacement" 
//                                         value={formValue.replacement || ""} 
//                                         onChange={e => formHandle(e)} 
//                                         className="form-control" 
//                                         required 
//                                         onWheel={(e) => e.target.blur()} 
//                                     />
//                                 </div>
//                             </div>

//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Product Weight (gm)</p>
//                                     <input 
//                                         type="number" 
//                                         name="weight" 
//                                         value={formValue.weight || ""} 
//                                         onChange={e => formHandle(e)} 
//                                         className="form-control" 
//                                         required 
//                                         onWheel={(e) => e.target.blur()} 
//                                     />
//                                 </div>
//                             </div>

//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">
//                                         Choose Tags <span className="fw-normal text-secondary">(optional)</span>
//                                     </p>
//                                     <select 
//                                         name="tags" 
//                                         value={formValue.tags || ""} 
//                                         onChange={e => formHandle(e)} 
//                                         className="form-select"
//                                     >
//                                         <option value="">Choose Any Tag</option>
//                                         <option value="top picks">Top Picks</option>
//                                         <option value="new arrival">New Arrival</option>
//                                     </select>
//                                 </div>
//                             </div>

//                             <div className="col-lg-6 col-12 mb-2">
//                                 <p className="mb-0 fw-bold">Choose Product Age Group</p>
//                                 {ageGroupError && (
//                                     <p ref={errorRef} className="text-danger fw-normal mb-1">
//                                         Please select at least one option!
//                                     </p>
//                                 )}
//                                 {ageGroupOptions.map((option, index) => (
//                                     <div key={index} className="form-check">
//                                         <input
//                                             type="checkbox"
//                                             id={option}
//                                             checked={ageGroupSelectedOptions.includes(option)}
//                                             onChange={() => handleAgeGroupChange(option)}
//                                             className="form-check-input"
//                                         />
//                                         <label htmlFor={option} className="form-check-label">
//                                             {option}
//                                         </label>
//                                     </div>
//                                 ))}
//                             </div>

//                             <div className="col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Product Description</p>
//                                     <div className="text-editor bg-white rounded">
//                                         <ReactQuill 
//                                             theme="snow" 
//                                             value={descriptionValue} 
//                                             onChange={setDescriptionValue} 
//                                             placeholder={"Write something awesome..."} 
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className="col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Material</p>
//                                     <div className="text-editor bg-white">
//                                         <EditorToolbar />
//                                         <ReactQuill 
//                                             theme="snow" 
//                                             value={keyvalue} 
//                                             onChange={setKeyValue} 
//                                             placeholder={"Write something awesome..."} 
//                                             modules={modules} 
//                                             formats={formats} 
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className="col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Dimensions</p>
//                                     <div className="text-editor bg-white">
//                                         <ReactQuill 
//                                             theme="snow" 
//                                             value={specificationvalue} 
//                                             onChange={setSpecificationValue} 
//                                             placeholder={"Write something awesome..."} 
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className="col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Care Instructions</p>
//                                     <div className="text-editor bg-white">
//                                         <ReactQuill 
//                                             theme="snow" 
//                                             name="other_info" 
//                                             value={otherValue} 
//                                             onChange={setOtherValue} 
//                                             placeholder={"Write something awesome..."} 
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className="col-12">
//                                 <div className="form-group text-end">
//                                     <button 
//                                         className="btn btn-primary" 
//                                         type="submit" 
//                                         disabled={loading}
//                                     >
//                                         {loading ? "Saving..." : "Post"}
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     </form>
//                 </div>
//             </Container>
//         </>
//     )
// }

// export default AddProduct
















// import React, { useRef, useState } from "react"
// import { Helmet } from 'react-helmet-async';
// import { Container } from "@mui/material";
// import ReactQuill from 'react-quill';
// import axios from "axios";
// import Swal from 'sweetalert2';
// import { useNavigate } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";

// import { Url, awsFileUrl } from "../url/url";
// import 'react-quill/dist/quill.snow.css';
// import EditorToolbar, { modules, formats } from "../utils/EditorToolbar";
// import "../App.css"
// import { productdata } from "../redux/slice/product";

// const ageGroupOptions = ['0-12 months', '1-2 years', '3+ years', '5+ years', '10+ years'];

// const AddProduct = () => {
//     const navigate = useNavigate()
//     const dispatch = useDispatch()
//     const categoryAllData = useSelector(store => store.category.data)
//     const subcategoryAllData = useSelector(store => store.subcategory.data)

//     const [keyvalue, setKeyValue] = useState('');
//     const [specificationvalue, setSpecificationValue] = useState('');
//     const [otherValue, setOtherValue] = useState('');
//     const [descriptionValue, setDescriptionValue] = useState('');
//     const [loading, setLoading] = useState(false)
//     const [formValue, setFormValue] = useState({});
//     const [isLimitedEdition, setIsLimitedEdition] = useState(false);

//     const [salePriceValue, setSalePriceValue] = useState('');

//     const [ageGroupSelectedOptions, setAgeGroupSelectedOptions] = useState([]);
//     const [ageGroupError, setAgeGroupError] = useState(false);
//     const errorRef = useRef(null);

//     const [uploadLoading, setUploadLoading] = useState(false);
//     const [progressValue, setProgressValue] = useState(0);
//     const [uploadStatus, setUploadStatus] = useState(false);

//     const [progressVideoValue, setProgressVideoValue] = useState(0)

//     const [multipleFileProgress, setMultipleFileProgress] = useState(0)
//     const [totalfiles, setTotalFiles] = useState(0)
//     const [totalUpload, setTotalUpload] = useState(0)
//     const [multipleFileStatus, setMultipleFileStatus] = useState(false)

//     const handleAgeGroupChange = (option) => {
//         setAgeGroupSelectedOptions((prev) =>
//             prev.includes(option)
//                 ? prev.filter((item) => item !== option)
//                 : [...prev, option]
//         );
//     };

//     const formHandle = (e) => {
//         const name = e.target.name
//         const value = e.target.value
//         setFormValue({ ...formValue, [name]: value })
//     }

//     // MRP ya Discount change hone par Sale Price auto-calculate karo
// const handleMrpOrDiscount = (e) => {
//     const name = e.target.name;
//     const value = e.target.value;
//     const updated = { ...formValue, [name]: value };
//     setFormValue(updated);

//     const mrp = parseFloat(name === 'mrp' ? value : updated.mrp) || 0;
//     const discountRaw = name === 'discount' ? value : updated.discount;
//     const discount = parseFloat(discountRaw);

//     // Discount field clear kar diya ya empty hai
//     if (!discountRaw || discountRaw === '' || Number.isNaN(discount) || discount <= 0) {
//         setSalePriceValue('');
//         setFormValue({ ...updated, salePrice: '' });
//         return;
//     }

//     if (mrp > 0) {
//         // Math.round se integer milega, .00 nahi aayega
//         const calculated = String(Math.round(mrp - (mrp * discount) / 100));
//         setSalePriceValue(calculated);
//         setFormValue({ ...updated, salePrice: calculated });
//     }
// };

//     const fileHandle = async (e) => {
//         const files = e.target.files;
//         const name = e.target.name;
//         const uploadedFiles = [];
//         setTotalFiles(files?.length);
//         setTotalUpload(0);
//         setMultipleFileProgress(0);
//         setMultipleFileStatus(true);

//         try {
//             await Array.from(files).reduce(async (previousPromise, file, i) => {
//                 await previousPromise;
//                 if (file) {
//                     const response = await axios.post(`${Url}/api/createPresignedUrl/products`, {
//                         fileName: file.name,
//                         fileType: file.type
//                     });

//                     if (response.status === 200) {
//                         const { preSignedUrl, key } = response?.data;
//                         const responseFileSave = await axios.put(preSignedUrl, file, {
//                             onUploadProgress: (progressEvent) => {
//                                 const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                                 setMultipleFileProgress(progress);
//                             },
//                         });

//                         if (responseFileSave.status === 200) {
//                             const fileUrl = `${awsFileUrl}/${key}`;
//                             setTotalUpload(i + 1);
//                             uploadedFiles.push(fileUrl);
//                         } else {
//                             throw new Error('File upload failed');
//                         }
//                     }
//                 }
//             }, Promise.resolve());

//             setFormValue({ ...formValue, [name]: uploadedFiles });
//             setMultipleFileStatus(false);
//             setUploadStatus(true);
//         } catch (error) {
//             console.log(error);
//         } finally {
//             setMultipleFileStatus(false);
//             setProgressValue(0);
//         }
//     };

//     const thumbnailHandle = async (e) => {
//         const file = e.target.files[0]
//         const name = e.target.name
//         setUploadLoading(true)

//         try {
//             if (file) {
//                 const response = await axios.post(`${Url}/api/createPresignedUrl/products`, {
//                     fileName: file.name,
//                     fileType: file.type
//                 })

//                 if (response.status === 200) {
//                     const { preSignedUrl, key } = response?.data
//                     const responseFileSave = await axios.put(preSignedUrl, file, {
//                         onUploadProgress: (progressEvent) => {
//                             const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                             setProgressValue(progress)
//                         },
//                     })

//                     if (responseFileSave.status === 200) {
//                         const fileUrl = `${awsFileUrl}/${key}`
//                         setFormValue({ ...formValue, [name]: fileUrl })
//                         setUploadStatus(true)
//                         setUploadLoading(false)
//                         setProgressValue(0)
//                     } else {
//                         setUploadLoading(false)
//                         setProgressValue(0)
//                         setUploadStatus(false)
//                     }
//                     setUploadLoading(false)
//                 }
//                 setUploadLoading(false)
//             }
//         } catch (error) {
//             console.log(error);
//             setUploadLoading(false)
//         }
//         setUploadLoading(false)
//     }

//     const videoHandle = async (e) => {
//         const file = e.target.files[0]
//         const name = e.target.name

//         try {
//             if (file) {
//                 const response = await axios.post(`${Url}/api/createPresignedUrl/products/video`, {
//                     fileName: file.name,
//                     fileType: file.type
//                 })

//                 if (response.status === 200) {
//                     const { preSignedUrl, key } = response?.data
//                     const responseFileSave = await axios.put(preSignedUrl, file, {
//                         onUploadProgress: (progressEvent) => {
//                             const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                             setProgressVideoValue(progress)
//                         },
//                     })

//                     if (responseFileSave.status === 200) {
//                         const fileUrl = `${awsFileUrl}/${key}`
//                         setFormValue({ ...formValue, [name]: fileUrl })
//                         console.log("Video uploaded:", fileUrl);
//                     }
//                 }
//             }
//         } catch (error) {
//             console.log(error);
//         }
//     }

//     const submit = async (e) => {
//         e.preventDefault();
//         setLoading(true);
//         setAgeGroupError(false);

//         // Validate age group
//         if (ageGroupSelectedOptions.length === 0) {
//             setAgeGroupError(true);
//             errorRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
//             setLoading(false);
//             return;
//         }

//         // Validate description aur care instructions
//         if (!descriptionValue || !otherValue) {
//             Swal.fire("Description and Care Instructions are required!");
//             setLoading(false);
//             return;
//         }

//         // Check type
//         if (!formValue.type) {
//             Swal.fire("Please select Product Type!");
//             setLoading(false);
//             return;
//         }

//         // Check subcategory
//         if (!formValue.subcategory) {
//             Swal.fire("Please select Sub Category!");
//             setLoading(false);
//             return;
//         }

//         // Check sale price
//         if (!formValue.salePrice && !salePriceValue) {
//             Swal.fire("Please enter Sale Price!");
//             setLoading(false);
//             return;
//         }

//         const dataValue = {
//             ...formValue,
//             description: descriptionValue,
//             specification: specificationvalue,
//             keyFeature: keyvalue,
//             otherInfo: otherValue,
//             ageGroup: ageGroupSelectedOptions,
//             limitedEdition: isLimitedEdition,
//             salePrice: salePriceValue || formValue.salePrice,
//         };

//         try {
//             const res = await axios.post(`${Url}/product/add`, dataValue, {
//                 headers: {
//                     'Content-Type': 'application/json'
//                 }
//             });

//             console.log("RESPONSE:", res.data);

//             Swal.fire({
//                 position: "top-end",
//                 icon: "success",
//                 title: "Product Added Successfully",
//                 showConfirmButton: false,
//                 timer: 1500
//             });

//             dispatch(productdata());
//             navigate("/dashboard/products");

//         } catch (error) {
//             console.error("ADD PRODUCT ERROR:", error);
//             Swal.fire({
//                 position: "top-end",
//                 icon: "error",
//                 title: error?.response?.data?.message || "Something Went Wrong",
//                 showConfirmButton: false,
//                 timer: 1500
//             });
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <>
//             <Helmet>
//                 <title> Dashboard: Add Product </title>
//             </Helmet>

//             <Container>
//                 <div className="mb-4 text-primary">
//                     <h2 className="text-capitalize">Add new product</h2>
//                 </div>
//                 <div className="p-3 bg-light rounded shadow border">
//                     <form action="" onSubmit={e => submit(e)}>
//                         <div className="row">

//                             {/* Product Name */}
//                             <div className="col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Product Name</p>
//                                     <input
//                                         type="text"
//                                         name="productName"
//                                         value={formValue.productName || ""}
//                                         onChange={e => formHandle(e)}
//                                         className="form-control"
//                                         required
//                                     />
//                                 </div>
//                             </div>

//                             {/* Limited Edition */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Limited Edition</p>
//                                     <div className="form-check mt-1">
//                                         <input
//                                             type="checkbox"
//                                             className="form-check-input"
//                                             id="limitedEdition"
//                                             checked={isLimitedEdition}
//                                             onChange={(e) => setIsLimitedEdition(e.target.checked)}
//                                         />
//                                         <span className="form-check-label ms-2">
//                                             Mark as Limited Edition
//                                         </span>
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Short Description */}
//                             <div className="col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Short Description</p>
//                                     <textarea
//                                         className="form-control"
//                                         name="shortDescription"
//                                         value={formValue.shortDescription || ""}
//                                         onChange={e => formHandle(e)}
//                                         rows="3"
//                                         required
//                                     />
//                                 </div>
//                             </div>

//                             {/* Image Alt Tag */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Image Alt Tag</p>
//                                     <input
//                                         type="text"
//                                         name="altTag"
//                                         value={formValue.altTag || ""}
//                                         onChange={e => formHandle(e)}
//                                         className="form-control"
//                                         required
//                                     />
//                                 </div>
//                             </div>

//                             {/* Thumbnail Image */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Thumbnail Image</p>
//                                     <input
//                                         type="file"
//                                         name="thumbnailImage"
//                                         onChange={e => thumbnailHandle(e)}
//                                         accept="image/*"
//                                         className="form-control"
//                                         required
//                                     />
//                                     <div className="d-flex justify-content-end gap-2 pt-2">
//                                         {uploadLoading && progressValue && (
//                                             <progress
//                                                 className="flex-grow-1"
//                                                 value={progressValue}
//                                                 max="100"
//                                                 style={{ height: "5px" }}
//                                             />
//                                         )}
//                                         {uploadStatus && (
//                                             <small className="fs-10 text-success">
//                                                 {uploadLoading ? `${progressValue}%` : 'success'}
//                                             </small>
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Multiple Images */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Images</p>
//                                     <input
//                                         type="file"
//                                         name="images"
//                                         multiple
//                                         onChange={e => fileHandle(e)}
//                                         className="form-control"
//                                         required
//                                         accept="image/*"
//                                     />
//                                     {multipleFileStatus && (
//                                         <progress
//                                             className="w-100"
//                                             value={multipleFileProgress}
//                                             max="100"
//                                             style={{ height: "5px" }}
//                                         />
//                                     )}
//                                     {totalfiles !== 0 && (
//                                         <div className="d-flex justify-content-end gap-2 pt-2 align-items-center">
//                                             <progress
//                                                 className="flex-grow-1"
//                                                 value={(totalUpload / totalfiles) * 100}
//                                                 max="100"
//                                                 style={{ height: "5px" }}
//                                             />
//                                             <small className="fs-10 text-secondary w-max-content">
//                                                 {totalUpload}/{totalfiles}
//                                             </small>
//                                             <small className="fs-10 text-success w-max-content">
//                                                 {((totalUpload / totalfiles) * 100).toFixed(1)}%
//                                             </small>
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>

//                             {/* Product Video */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">
//                                         Product Video <span className="fw-normal text-secondary">(optional)</span>
//                                     </p>
//                                     <input
//                                         type="file"
//                                         name="video"
//                                         accept="video/*"
//                                         onChange={e => videoHandle(e)}
//                                         className="form-control"
//                                     />
//                                     <div className="d-flex justify-content-end gap-2 pt-2">
//                                         {progressVideoValue > 0 && progressVideoValue < 100 && (
//                                             <progress
//                                                 className="flex-grow-1"
//                                                 value={progressVideoValue}
//                                                 max="100"
//                                                 style={{ height: "5px" }}
//                                             />
//                                         )}
//                                         {progressVideoValue > 0 && (
//                                             <small className="fs-10 text-success">
//                                                 {progressVideoValue < 100 ? `${progressVideoValue}%` : 'success'}
//                                             </small>
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* MRP */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">MRP (<i className="fa-solid fa-indian-rupee-sign text-muted fa-sm" />)</p>
//                                     <input
//                                         type="number"
//                                         name="mrp"
//                                         value={formValue.mrp || ""}
//                                         onChange={handleMrpOrDiscount}
//                                         className="form-control"
//                                         required
//                                         onWheel={(e) => e.target.blur()}
//                                     />
//                                 </div>
//                             </div>

//                             {/* Discount */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">
//                                         Discount (%) <span className="fw-normal text-secondary">(optional)</span>
//                                     </p>
//                                     <input
//                                         type="number"
//                                         name="discount"
//                                         value={formValue.discount || ""}
//                                         onChange={handleMrpOrDiscount}
//                                         className="form-control"
//                                         onWheel={(e) => e.target.blur()}
//                                     />
//                                 </div>
//                             </div>

//                             {/* Sale Price — auto ya manual */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">
//                                         Sale Price (<i className="fa-solid fa-indian-rupee-sign text-muted fa-sm" />)
//                                         {salePriceValue && (
//                                             <span className="fw-normal text-success ms-2" style={{ fontSize: '12px' }}>
//                                                 ✓ Auto-calculated
//                                             </span>
//                                         )}
//                                     </p>
//                                     <input
//                                         type="number"
//                                         name="salePrice"
//                                         value={salePriceValue || formValue.salePrice || ""}
//                                         onChange={(e) => {
//                                             setSalePriceValue(e.target.value);
//                                             setFormValue({ ...formValue, salePrice: e.target.value });
//                                         }}
//                                         className="form-control"
//                                         required
//                                         onWheel={(e) => e.target.blur()}
//                                         placeholder="Discount daalne par auto fill hoga"
//                                     />
//                                 </div>
//                             </div>

//                             {/* Height / Width / Depth / Unit */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="row">
//                                     <div className="col-lg-3 col-md-6 mb-2">
//                                         <div className="form-group">
//                                             <p className="mb-0 fw-bold">Height</p>
//                                             <input
//                                                 type="text"
//                                                 name="height"
//                                                 value={formValue.height || ""}
//                                                 onChange={e => formHandle(e)}
//                                                 className="form-control"
//                                                 required
//                                             />
//                                         </div>
//                                     </div>
//                                     <div className="col-lg-3 col-md-6 mb-2">
//                                         <div className="form-group">
//                                             <p className="mb-0 fw-bold">Width</p>
//                                             <input
//                                                 type="text"
//                                                 name="width"
//                                                 value={formValue.width || ""}
//                                                 onChange={e => formHandle(e)}
//                                                 className="form-control"
//                                                 required
//                                             />
//                                         </div>
//                                     </div>
//                                     <div className="col-lg-3 col-md-6 mb-2">
//                                         <div className="form-group">
//                                             <p className="mb-0 fw-bold">Depth</p>
//                                             <input
//                                                 type="text"
//                                                 name="depth"
//                                                 value={formValue.depth || ""}
//                                                 onChange={e => formHandle(e)}
//                                                 className="form-control"
//                                                 required
//                                             />
//                                         </div>
//                                     </div>
//                                     <div className="col-lg-3 col-md-6 mb-2">
//                                         <div className="form-group">
//                                             <p className="mb-0 fw-bold">Unit</p>
//                                             <select
//                                                 name="measurement"
//                                                 value={formValue.measurement || ""}
//                                                 onChange={e => formHandle(e)}
//                                                 className="form-select"
//                                                 required
//                                             >
//                                                 <option value='' disabled>Choose</option>
//                                                 <option value="cm">cm</option>
//                                             </select>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Total Product */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Total Product</p>
//                                     <input
//                                         type="number"
//                                         name="totalProduct"
//                                         value={formValue.totalProduct || ""}
//                                         onChange={e => formHandle(e)}
//                                         className="form-control"
//                                         required
//                                         onWheel={(e) => e.target.blur()}
//                                     />
//                                 </div>
//                             </div>

//                             {/* Category */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Category</p>
//                                     <select
//                                         name="category"
//                                         value={formValue.category || ""}
//                                         onChange={e => formHandle(e)}
//                                         className="form-select"
//                                         required
//                                     >
//                                         <option value='' disabled>Category Choose</option>
//                                         {categoryAllData.map((cv, i) => (
//                                             <option value={cv.category} key={i}>{cv.category}</option>
//                                         ))}
//                                     </select>
//                                 </div>
//                             </div>

//                             {/* Sub Category */}
//                     {/* Sub Category */}
// <div className="col-lg-6 col-12 mb-2">
//     <div className="form-group">
//         <p className="mb-0 fw-bold">Sub Category</p>
//         <select
//             name="subcategory"
//             value={formValue.subcategory || ""}
//             onChange={e => formHandle(e)}
//             className="form-select"
//             required
//         >
//             <option value='' disabled>Choose</option>
//             {formValue.category && subcategoryAllData
//                 // ✅ category._id se match karo ya category string se — dono handle
//                 .filter(val => {
//                     const catId = val.category?._id || val.category
//                     return catId === formValue.category || val.category?.category === formValue.category
//                 })
//                 .map((value, i) => (
//                     <option value={value.subcategory} key={i}>
//                         {value.subcategory}
//                     </option>
//                 ))
//             }
//         </select>
//     </div>
// </div>

//                             {/* Type */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Type</p>
//                                     <select
//                                         name="type"
//                                         value={formValue.type || ""}
//                                         onChange={e => formHandle(e)}
//                                         className="form-select"
//                                         required
//                                     >
//                                         <option value='' disabled>Choose Type (Optional)</option>
//                                         <option value="None">None</option>
//                                         <option value="big">Big</option>
//                                         <option value="small">Small</option>
//                                     </select>
//                                 </div>
//                             </div>

//                             {/* Batch No */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Batch No.</p>
//                                     <input
//                                         type="text"
//                                         name="batch"
//                                         value={formValue.batch || ""}
//                                         onChange={e => formHandle(e)}
//                                         className="form-control"
//                                         required
//                                     />
//                                 </div>
//                             </div>

//                             {/* SKU No */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">SKU No.</p>
//                                     <input
//                                         type="text"
//                                         name="sku"
//                                         value={formValue.sku || ""}
//                                         onChange={e => formHandle(e)}
//                                         className="form-control"
//                                         required
//                                     />
//                                 </div>
//                             </div>

//                             {/* Replacement */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Replacement (days)</p>
//                                     <input
//                                         type="number"
//                                         name="replacement"
//                                         value={formValue.replacement || ""}
//                                         onChange={e => formHandle(e)}
//                                         className="form-control"
//                                         required
//                                         onWheel={(e) => e.target.blur()}
//                                     />
//                                 </div>
//                             </div>

//                             {/* Weight */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Product Weight (gm)</p>
//                                     <input
//                                         type="number"
//                                         name="weight"
//                                         value={formValue.weight || ""}
//                                         onChange={e => formHandle(e)}
//                                         className="form-control"
//                                         required
//                                         onWheel={(e) => e.target.blur()}
//                                     />
//                                 </div>
//                             </div>

//                             {/* Tags */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">
//                                         Choose Tags <span className="fw-normal text-secondary">(optional)</span>
//                                     </p>
//                                     <select
//                                         name="tags"
//                                         value={formValue.tags || ""}
//                                         onChange={e => formHandle(e)}
//                                         className="form-select"
//                                     >
//                                         <option value="">Choose Any Tag</option>
//                                         <option value="top picks">Top Picks</option>
//                                         <option value="new arrival">New Arrival</option>
//                                     </select>
//                                 </div>
//                             </div>

//                             {/* Age Group */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <p className="mb-0 fw-bold">Choose Product Age Group</p>
//                                 {ageGroupError && (
//                                     <p ref={errorRef} className="text-danger fw-normal mb-1">
//                                         Please select at least one option!
//                                     </p>
//                                 )}
//                                 {ageGroupOptions.map((option, index) => (
//                                     <div key={index} className="form-check">
//                                         <input
//                                             type="checkbox"
//                                             id={option}
//                                             checked={ageGroupSelectedOptions.includes(option)}
//                                             onChange={() => handleAgeGroupChange(option)}
//                                             className="form-check-input"
//                                         />
//                                         <label htmlFor={option} className="form-check-label">
//                                             {option}
//                                         </label>
//                                     </div>
//                                 ))}
//                             </div>

//                             {/* Product Description */}
//                             <div className="col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Product Description</p>
//                                     <div className="text-editor bg-white rounded">
//                                         <ReactQuill
//                                             theme="snow"
//                                             value={descriptionValue}
//                                             onChange={setDescriptionValue}
//                                             placeholder={"Write something awesome..."}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Material */}
//                             <div className="col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">key Features</p>
//                                     <div className="text-editor bg-white">
//                                         <EditorToolbar />
//                                         <ReactQuill
//                                             theme="snow"
//                                             value={keyvalue}
//                                             onChange={setKeyValue}
//                                             placeholder={"Write something awesome..."}
//                                             modules={modules}
//                                             formats={formats}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Dimensions */}
//                             <div className="col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Specifications</p>
//                                     <div className="text-editor bg-white">
//                                         <ReactQuill
//                                             theme="snow"
//                                             value={specificationvalue}
//                                             onChange={setSpecificationValue}
//                                             placeholder={"Write something awesome..."}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Care Instructions */}
//                             <div className="col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Other Information</p>
//                                     <div className="text-editor bg-white">
//                                         <ReactQuill
//                                             theme="snow"
//                                             name="other_info"
//                                             value={otherValue}
//                                             onChange={setOtherValue}
//                                             placeholder={"Write something awesome..."}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Submit */}
//                             <div className="col-12">
//                                 <div className="form-group text-end">
//                                     <button
//                                         className="btn btn-primary"
//                                         type="submit"
//                                         disabled={loading}
//                                     >
//                                         {loading ? "Saving..." : "Post"}
//                                     </button>
//                                 </div>
//                             </div>

//                         </div>
//                     </form>
//                 </div>
//             </Container>
//         </>
//     )
// }

// export default AddProduct











// import React, { useRef, useState } from "react"
// import { Helmet } from 'react-helmet-async';
// import { Container } from "@mui/material";
// import ReactQuill from 'react-quill';
// import axios from "axios";
// import Swal from 'sweetalert2';
// import { useNavigate } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";

// import { Url, awsFileUrl } from "../url/url";
// import 'react-quill/dist/quill.snow.css';
// import EditorToolbar, { modules, formats } from "../utils/EditorToolbar";
// import "../App.css"
// import { productdata } from "../redux/slice/product";

// const ageGroupOptions = ['0-12 months', '1-2 years', '3+ years', '5+ years', '10+ years'];

// const AddProduct = () => {
//     const navigate = useNavigate()
//     const dispatch = useDispatch()
//     const categoryAllData = useSelector(store => store.category.data)
//     const subcategoryAllData = useSelector(store => store.subcategory.data)

//     const [keyvalue, setKeyValue] = useState('');
//     const [specificationvalue, setSpecificationValue] = useState('');
//     const [otherValue, setOtherValue] = useState('');
//     const [descriptionValue, setDescriptionValue] = useState('');
//     const [loading, setLoading] = useState(false)
//     const [formValue, setFormValue] = useState({});
//     const [isLimitedEdition, setIsLimitedEdition] = useState(false);

//     const [salePriceValue, setSalePriceValue] = useState('');

//     const [ageGroupSelectedOptions, setAgeGroupSelectedOptions] = useState([]);
//     const [ageGroupError, setAgeGroupError] = useState(false);
//     const errorRef = useRef(null);

//     const [uploadLoading, setUploadLoading] = useState(false);
//     const [progressValue, setProgressValue] = useState(0);
//     const [uploadStatus, setUploadStatus] = useState(false);

//     const [progressVideoValue, setProgressVideoValue] = useState(0)

//     const [multipleFileProgress, setMultipleFileProgress] = useState(0)
//     const [totalfiles, setTotalFiles] = useState(0)
//     const [totalUpload, setTotalUpload] = useState(0)
//     const [multipleFileStatus, setMultipleFileStatus] = useState(false)

//     const handleAgeGroupChange = (option) => {
//         setAgeGroupSelectedOptions((prev) =>
//             prev.includes(option)
//                 ? prev.filter((item) => item !== option)
//                 : [...prev, option]
//         );
//     };

//     const formHandle = (e) => {
//         const name = e.target.name
//         const value = e.target.value
//         setFormValue({ ...formValue, [name]: value })
//     }

//     // MRP ya Discount change hone par Sale Price auto-calculate karo
//     const handleMrpOrDiscount = (e) => {
//         const name = e.target.name;
//         const value = e.target.value;
//         const updated = { ...formValue, [name]: value };
//         setFormValue(updated);

//         const mrp = parseFloat(name === 'mrp' ? value : updated.mrp) || 0;
//         const discountRaw = name === 'discount' ? value : updated.discount;
//         const discount = parseFloat(discountRaw);

//         // Discount field clear kar diya ya empty hai
//         if (!discountRaw || discountRaw === '' || Number.isNaN(discount) || discount <= 0) {
//             setSalePriceValue('');
//             setFormValue({ ...updated, salePrice: '' });
//             return;
//         }

//         if (mrp > 0) {
//             // Math.round se integer milega, .00 nahi aayega
//             const calculated = String(Math.round(mrp - (mrp * discount) / 100));
//             setSalePriceValue(calculated);
//             setFormValue({ ...updated, salePrice: calculated });
//         }
//     };

//     const fileHandle = async (e) => {
//         const files = e.target.files;
//         const name = e.target.name;
//         const uploadedFiles = [];
//         setTotalFiles(files?.length);
//         setTotalUpload(0);
//         setMultipleFileProgress(0);
//         setMultipleFileStatus(true);

//         try {
//             await Array.from(files).reduce(async (previousPromise, file, i) => {
//                 await previousPromise;
//                 if (file) {
//                     const response = await axios.post(`${Url}/api/createPresignedUrl/products`, {
//                         fileName: file.name,
//                         fileType: file.type
//                     });

//                     if (response.status === 200) {
//                         const { preSignedUrl, key } = response?.data;
//                         const responseFileSave = await axios.put(preSignedUrl, file, {
//                             onUploadProgress: (progressEvent) => {
//                                 const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                                 setMultipleFileProgress(progress);
//                             },
//                         });

//                         if (responseFileSave.status === 200) {
//                             const fileUrl = `${awsFileUrl}/${key}`;
//                             setTotalUpload(i + 1);
//                             uploadedFiles.push(fileUrl);
//                         } else {
//                             throw new Error('File upload failed');
//                         }
//                     }
//                 }
//             }, Promise.resolve());

//             setFormValue({ ...formValue, [name]: uploadedFiles });
//             setMultipleFileStatus(false);
//             setUploadStatus(true);
//         } catch (error) {
//             console.log(error);
//             Swal.fire("Images upload failed, please try again!");
//         } finally {
//             setMultipleFileStatus(false);
//             setProgressValue(0);
//         }
//     };

//     const thumbnailHandle = async (e) => {
//         const file = e.target.files[0]
//         const name = e.target.name
//         setUploadLoading(true)
//         setUploadStatus(false)

//         try {
//             if (file) {
//                 const response = await axios.post(`${Url}/api/createPresignedUrl/products`, {
//                     fileName: file.name,
//                     fileType: file.type
//                 })

//                 if (response.status === 200) {
//                     const { preSignedUrl, key } = response?.data
//                     const responseFileSave = await axios.put(preSignedUrl, file, {
//                         onUploadProgress: (progressEvent) => {
//                             const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                             setProgressValue(progress)
//                         },
//                     })

//                     if (responseFileSave.status === 200) {
//                         const fileUrl = `${awsFileUrl}/${key}`
//                         setFormValue({ ...formValue, [name]: fileUrl })
//                         setUploadStatus(true)
//                         setUploadLoading(false)
//                         setProgressValue(0)
//                     } else {
//                         setUploadLoading(false)
//                         setProgressValue(0)
//                         setUploadStatus(false)
//                         Swal.fire("Thumbnail upload failed, please try again!");
//                     }
//                 } else {
//                     setUploadLoading(false)
//                 }
//             } else {
//                 setUploadLoading(false)
//             }
//         } catch (error) {
//             console.log(error);
//             setUploadLoading(false)
//             setUploadStatus(false)
//             Swal.fire("Thumbnail upload failed, please try again!");
//         }
//     }

//     const videoHandle = async (e) => {
//         const file = e.target.files[0]
//         const name = e.target.name

//         try {
//             if (file) {
//                 const response = await axios.post(`${Url}/api/createPresignedUrl/products/video`, {
//                     fileName: file.name,
//                     fileType: file.type
//                 })

//                 if (response.status === 200) {
//                     const { preSignedUrl, key } = response?.data
//                     const responseFileSave = await axios.put(preSignedUrl, file, {
//                         onUploadProgress: (progressEvent) => {
//                             const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                             setProgressVideoValue(progress)
//                         },
//                     })

//                     if (responseFileSave.status === 200) {
//                         const fileUrl = `${awsFileUrl}/${key}`
//                         setFormValue({ ...formValue, [name]: fileUrl })
//                         console.log("Video uploaded:", fileUrl);
//                     }
//                 }
//             }
//         } catch (error) {
//             console.log(error);
//         }
//     }

//     const submit = async (e) => {
//         e.preventDefault();
//         setLoading(true);
//         setAgeGroupError(false);

//         // Validate age group
//         if (ageGroupSelectedOptions.length === 0) {
//             setAgeGroupError(true);
//             errorRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
//             setLoading(false);
//             return;
//         }

//         // Validate description aur care instructions
//         if (!descriptionValue || !otherValue) {
//             Swal.fire("Description and Care Instructions are required!");
//             setLoading(false);
//             return;
//         }

//         // Check type
//         if (!formValue.type) {
//             Swal.fire("Please select Product Type!");
//             setLoading(false);
//             return;
//         }

//         // Check subcategory
//         if (!formValue.subcategory) {
//             Swal.fire("Please select Sub Category!");
//             setLoading(false);
//             return;
//         }

//         // Check sale price
//         if (!formValue.salePrice && !salePriceValue) {
//             Swal.fire("Please enter Sale Price!");
//             setLoading(false);
//             return;
//         }

//         // 🔥 Thumbnail upload abhi chal raha hai ya complete nahi hua
//         if (uploadLoading) {
//             Swal.fire("Thumbnail image abhi upload ho raha hai, thoda ruk jao!");
//             setLoading(false);
//             return;
//         }
//         if (!formValue.thumbnailImage) {
//             Swal.fire("Please upload Thumbnail Image!");
//             setLoading(false);
//             return;
//         }

//         // 🔥 Multiple images upload abhi chal raha hai ya complete nahi hua
//         if (multipleFileStatus) {
//             Swal.fire("Images abhi upload ho rahi hain, thoda ruk jao!");
//             setLoading(false);
//             return;
//         }
//         if (!formValue.images || formValue.images.length === 0) {
//             Swal.fire("Please upload Product Images!");
//             setLoading(false);
//             return;
//         }

//         const dataValue = {
//             ...formValue,
//             description: descriptionValue,
//             specification: specificationvalue,
//             keyFeature: keyvalue,
//             otherInfo: otherValue,
//             ageGroup: ageGroupSelectedOptions,
//             limitedEdition: isLimitedEdition,
//             salePrice: salePriceValue || formValue.salePrice,
//         };

//         try {
//             const res = await axios.post(`${Url}/product/add`, dataValue, {
//                 headers: {
//                     'Content-Type': 'application/json'
//                 }
//             });

//             console.log("RESPONSE:", res.data);

//             Swal.fire({
//                 position: "top-end",
//                 icon: "success",
//                 title: "Product Added Successfully",
//                 showConfirmButton: false,
//                 timer: 1500
//             });

//             dispatch(productdata());
//             navigate("/dashboard/products");

//         } catch (error) {
//             console.error("ADD PRODUCT ERROR:", error);
//             Swal.fire({
//                 position: "top-end",
//                 icon: "error",
//                 title: error?.response?.data?.message || "Something Went Wrong",
//                 showConfirmButton: false,
//                 timer: 1500
//             });
//         } finally {
//             setLoading(false);
//         }
//     };

//     // 🔥 Submit button kab disable rahega — saving ho rahi ho ya koi upload chal raha ho
//     const isSubmitDisabled = loading || uploadLoading || multipleFileStatus;

//     return (
//         <>
//             <Helmet>
//                 <title> Dashboard: Add Product </title>
//             </Helmet>

//             <Container>
//                 <div className="mb-4 text-primary">
//                     <h2 className="text-capitalize">Add new product</h2>
//                 </div>
//                 <div className="p-3 bg-light rounded shadow border">
//                     <form action="" onSubmit={e => submit(e)}>
//                         <div className="row">

//                             {/* Product Name */}
//                             <div className="col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Product Name</p>
//                                     <input
//                                         type="text"
//                                         name="productName"
//                                         value={formValue.productName || ""}
//                                         onChange={e => formHandle(e)}
//                                         className="form-control"
//                                         required
//                                     />
//                                 </div>
//                             </div>

//                             {/* Limited Edition */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Limited Edition</p>
//                                     <div className="form-check mt-1">
//                                         <input
//                                             type="checkbox"
//                                             className="form-check-input"
//                                             id="limitedEdition"
//                                             checked={isLimitedEdition}
//                                             onChange={(e) => setIsLimitedEdition(e.target.checked)}
//                                         />
//                                         <span className="form-check-label ms-2">
//                                             Mark as Limited Edition
//                                         </span>
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Short Description */}
//                             <div className="col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Short Description</p>
//                                     <textarea
//                                         className="form-control"
//                                         name="shortDescription"
//                                         value={formValue.shortDescription || ""}
//                                         onChange={e => formHandle(e)}
//                                         rows="3"
//                                         required
//                                     />
//                                 </div>
//                             </div>

//                             {/* Image Alt Tag */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Image Alt Tag</p>
//                                     <input
//                                         type="text"
//                                         name="altTag"
//                                         value={formValue.altTag || ""}
//                                         onChange={e => formHandle(e)}
//                                         className="form-control"
//                                         required
//                                     />
//                                 </div>
//                             </div>

//                             {/* Thumbnail Image */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Thumbnail Image</p>
//                                     <input
//                                         type="file"
//                                         name="thumbnailImage"
//                                         onChange={e => thumbnailHandle(e)}
//                                         accept="image/*"
//                                         className="form-control"
//                                         required
//                                     />
//                                     <div className="d-flex justify-content-end gap-2 pt-2">
//                                         {uploadLoading && progressValue > 0 && (
//                                             <progress
//                                                 className="flex-grow-1"
//                                                 value={progressValue}
//                                                 max="100"
//                                                 style={{ height: "5px" }}
//                                             />
//                                         )}
//                                         {uploadLoading && (
//                                             <small className="fs-10 text-secondary">
//                                                 Uploading... {progressValue}%
//                                             </small>
//                                         )}
//                                         {!uploadLoading && uploadStatus && formValue.thumbnailImage && (
//                                             <small className="fs-10 text-success">
//                                                 ✓ success
//                                             </small>
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Multiple Images */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Images</p>
//                                     <input
//                                         type="file"
//                                         name="images"
//                                         multiple
//                                         onChange={e => fileHandle(e)}
//                                         className="form-control"
//                                         required
//                                         accept="image/*"
//                                     />
//                                     {multipleFileStatus && (
//                                         <progress
//                                             className="w-100"
//                                             value={multipleFileProgress}
//                                             max="100"
//                                             style={{ height: "5px" }}
//                                         />
//                                     )}
//                                     {totalfiles !== 0 && (
//                                         <div className="d-flex justify-content-end gap-2 pt-2 align-items-center">
//                                             <progress
//                                                 className="flex-grow-1"
//                                                 value={(totalUpload / totalfiles) * 100}
//                                                 max="100"
//                                                 style={{ height: "5px" }}
//                                             />
//                                             <small className="fs-10 text-secondary w-max-content">
//                                                 {totalUpload}/{totalfiles}
//                                             </small>
//                                             <small className="fs-10 text-success w-max-content">
//                                                 {((totalUpload / totalfiles) * 100).toFixed(1)}%
//                                             </small>
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>

//                             {/* Product Video */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">
//                                         Product Video <span className="fw-normal text-secondary">(optional)</span>
//                                     </p>
//                                     <input
//                                         type="file"
//                                         name="video"
//                                         accept="video/*"
//                                         onChange={e => videoHandle(e)}
//                                         className="form-control"
//                                     />
//                                     <div className="d-flex justify-content-end gap-2 pt-2">
//                                         {progressVideoValue > 0 && progressVideoValue < 100 && (
//                                             <progress
//                                                 className="flex-grow-1"
//                                                 value={progressVideoValue}
//                                                 max="100"
//                                                 style={{ height: "5px" }}
//                                             />
//                                         )}
//                                         {progressVideoValue > 0 && (
//                                             <small className="fs-10 text-success">
//                                                 {progressVideoValue < 100 ? `${progressVideoValue}%` : 'success'}
//                                             </small>
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* MRP */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">MRP (<i className="fa-solid fa-indian-rupee-sign text-muted fa-sm" />)</p>
//                                     <input
//                                         type="number"
//                                         name="mrp"
//                                         value={formValue.mrp || ""}
//                                         onChange={handleMrpOrDiscount}
//                                         className="form-control"
//                                         required
//                                         onWheel={(e) => e.target.blur()}
//                                     />
//                                 </div>
//                             </div>

//                             {/* Discount */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">
//                                         Discount (%) <span className="fw-normal text-secondary">(optional)</span>
//                                     </p>
//                                     <input
//                                         type="number"
//                                         name="discount"
//                                         value={formValue.discount || ""}
//                                         onChange={handleMrpOrDiscount}
//                                         className="form-control"
//                                         onWheel={(e) => e.target.blur()}
//                                     />
//                                 </div>
//                             </div>

//                             {/* Sale Price — auto ya manual */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">
//                                         Sale Price (<i className="fa-solid fa-indian-rupee-sign text-muted fa-sm" />)
//                                         {salePriceValue && (
//                                             <span className="fw-normal text-success ms-2" style={{ fontSize: '12px' }}>
//                                                 ✓ Auto-calculated
//                                             </span>
//                                         )}
//                                     </p>
//                                     <input
//                                         type="number"
//                                         name="salePrice"
//                                         value={salePriceValue || formValue.salePrice || ""}
//                                         onChange={(e) => {
//                                             setSalePriceValue(e.target.value);
//                                             setFormValue({ ...formValue, salePrice: e.target.value });
//                                         }}
//                                         className="form-control"
//                                         required
//                                         onWheel={(e) => e.target.blur()}
//                                         placeholder="Discount daalne par auto fill hoga"
//                                     />
//                                 </div>
//                             </div>

//                             {/* Height / Width / Depth / Unit */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="row">
//                                     <div className="col-lg-3 col-md-6 mb-2">
//                                         <div className="form-group">
//                                             <p className="mb-0 fw-bold">Height</p>
//                                             <input
//                                                 type="text"
//                                                 name="height"
//                                                 value={formValue.height || ""}
//                                                 onChange={e => formHandle(e)}
//                                                 className="form-control"
//                                                 required
//                                             />
//                                         </div>
//                                     </div>
//                                     <div className="col-lg-3 col-md-6 mb-2">
//                                         <div className="form-group">
//                                             <p className="mb-0 fw-bold">Width</p>
//                                             <input
//                                                 type="text"
//                                                 name="width"
//                                                 value={formValue.width || ""}
//                                                 onChange={e => formHandle(e)}
//                                                 className="form-control"
//                                                 required
//                                             />
//                                         </div>
//                                     </div>
//                                     <div className="col-lg-3 col-md-6 mb-2">
//                                         <div className="form-group">
//                                             <p className="mb-0 fw-bold">Depth</p>
//                                             <input
//                                                 type="text"
//                                                 name="depth"
//                                                 value={formValue.depth || ""}
//                                                 onChange={e => formHandle(e)}
//                                                 className="form-control"
//                                                 required
//                                             />
//                                         </div>
//                                     </div>
//                                     <div className="col-lg-3 col-md-6 mb-2">
//                                         <div className="form-group">
//                                             <p className="mb-0 fw-bold">Unit</p>
//                                             <select
//                                                 name="measurement"
//                                                 value={formValue.measurement || ""}
//                                                 onChange={e => formHandle(e)}
//                                                 className="form-select"
//                                                 required
//                                             >
//                                                 <option value='' disabled>Choose</option>
//                                                 <option value="cm">cm</option>
//                                             </select>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Total Product */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Total Product</p>
//                                     <input
//                                         type="number"
//                                         name="totalProduct"
//                                         value={formValue.totalProduct || ""}
//                                         onChange={e => formHandle(e)}
//                                         className="form-control"
//                                         required
//                                         onWheel={(e) => e.target.blur()}
//                                     />
//                                 </div>
//                             </div>

//                             {/* Category */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Category</p>
//                                     <select
//                                         name="category"
//                                         value={formValue.category || ""}
//                                         onChange={e => formHandle(e)}
//                                         className="form-select"
//                                         required
//                                     >
//                                         <option value='' disabled>Category Choose</option>
//                                         {categoryAllData.map((cv, i) => (
//                                             <option value={cv.category} key={i}>{cv.category}</option>
//                                         ))}
//                                     </select>
//                                 </div>
//                             </div>

//                             {/* Sub Category */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Sub Category</p>
//                                     <select
//                                         name="subcategory"
//                                         value={formValue.subcategory || ""}
//                                         onChange={e => formHandle(e)}
//                                         className="form-select"
//                                         required
//                                     >
//                                         <option value='' disabled>Choose</option>
//                                         {formValue.category && subcategoryAllData
//                                             // ✅ category._id se match karo ya category string se — dono handle
//                                             .filter(val => {
//                                                 const catId = val.category?._id || val.category
//                                                 return catId === formValue.category || val.category?.category === formValue.category
//                                             })
//                                             .map((value, i) => (
//                                                 <option value={value.subcategory} key={i}>
//                                                     {value.subcategory}
//                                                 </option>
//                                             ))
//                                         }
//                                     </select>
//                                 </div>
//                             </div>

//                             {/* Type */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Type</p>
//                                     <select
//                                         name="type"
//                                         value={formValue.type || ""}
//                                         onChange={e => formHandle(e)}
//                                         className="form-select"
//                                         required
//                                     >
//                                         <option value='' disabled>Choose Type (Optional)</option>
//                                         <option value="None">None</option>
//                                         <option value="big">Big</option>
//                                         <option value="small">Small</option>
//                                     </select>
//                                 </div>
//                             </div>

//                             {/* Batch No */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Batch No.</p>
//                                     <input
//                                         type="text"
//                                         name="batch"
//                                         value={formValue.batch || ""}
//                                         onChange={e => formHandle(e)}
//                                         className="form-control"
//                                         required
//                                     />
//                                 </div>
//                             </div>

//                             {/* SKU No */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">SKU No.</p>
//                                     <input
//                                         type="text"
//                                         name="sku"
//                                         value={formValue.sku || ""}
//                                         onChange={e => formHandle(e)}
//                                         className="form-control"
//                                         required
//                                     />
//                                 </div>
//                             </div>

//                             {/* Replacement */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Replacement (days)</p>
//                                     <input
//                                         type="number"
//                                         name="replacement"
//                                         value={formValue.replacement || ""}
//                                         onChange={e => formHandle(e)}
//                                         className="form-control"
//                                         required
//                                         onWheel={(e) => e.target.blur()}
//                                     />
//                                 </div>
//                             </div>

//                             {/* Weight */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Product Weight (gm)</p>
//                                     <input
//                                         type="number"
//                                         name="weight"
//                                         value={formValue.weight || ""}
//                                         onChange={e => formHandle(e)}
//                                         className="form-control"
//                                         required
//                                         onWheel={(e) => e.target.blur()}
//                                     />
//                                 </div>
//                             </div>

//                             {/* Tags */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">
//                                         Choose Tags <span className="fw-normal text-secondary">(optional)</span>
//                                     </p>
//                                     <select
//                                         name="tags"
//                                         value={formValue.tags || ""}
//                                         onChange={e => formHandle(e)}
//                                         className="form-select"
//                                     >
//                                         <option value="">Choose Any Tag</option>
//                                         <option value="top picks">Top Picks</option>
//                                         <option value="new arrival">New Arrival</option>
//                                     </select>
//                                 </div>
//                             </div>

//                             {/* Age Group */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <p className="mb-0 fw-bold">Choose Product Age Group</p>
//                                 {ageGroupError && (
//                                     <p ref={errorRef} className="text-danger fw-normal mb-1">
//                                         Please select at least one option!
//                                     </p>
//                                 )}
//                                 {ageGroupOptions.map((option, index) => (
//                                     <div key={index} className="form-check">
//                                         <input
//                                             type="checkbox"
//                                             id={option}
//                                             checked={ageGroupSelectedOptions.includes(option)}
//                                             onChange={() => handleAgeGroupChange(option)}
//                                             className="form-check-input"
//                                         />
//                                         <label htmlFor={option} className="form-check-label">
//                                             {option}
//                                         </label>
//                                     </div>
//                                 ))}
//                             </div>

//                             {/* Product Description */}
//                             <div className="col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Product Description</p>
//                                     <div className="text-editor bg-white rounded">
//                                         <ReactQuill
//                                             theme="snow"
//                                             value={descriptionValue}
//                                             onChange={setDescriptionValue}
//                                             placeholder={"Write something awesome..."}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Material */}
//                             <div className="col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">key Features</p>
//                                     <div className="text-editor bg-white">
//                                         <EditorToolbar />
//                                         <ReactQuill
//                                             theme="snow"
//                                             value={keyvalue}
//                                             onChange={setKeyValue}
//                                             placeholder={"Write something awesome..."}
//                                             modules={modules}
//                                             formats={formats}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Dimensions */}
//                             <div className="col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Specifications</p>
//                                     <div className="text-editor bg-white">
//                                         <ReactQuill
//                                             theme="snow"
//                                             value={specificationvalue}
//                                             onChange={setSpecificationValue}
//                                             placeholder={"Write something awesome..."}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Care Instructions */}
//                             <div className="col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Other Information</p>
//                                     <div className="text-editor bg-white">
//                                         <ReactQuill
//                                             theme="snow"
//                                             name="other_info"
//                                             value={otherValue}
//                                             onChange={setOtherValue}
//                                             placeholder={"Write something awesome..."}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Submit */}
//                             <div className="col-12">
//                                 <div className="form-group text-end">
//                                     <button
//                                         className="btn btn-primary"
//                                         type="submit"
//                                         disabled={isSubmitDisabled}
//                                     >
//                                         {loading
//                                             ? "Saving..."
//                                             : (uploadLoading || multipleFileStatus)
//                                                 ? "Uploading..."
//                                                 : "Post"}
//                                     </button>
//                                 </div>
//                             </div>

//                         </div>
//                     </form>
//                 </div>
//             </Container>
//         </>
//     )
// }

// export default AddProduct











import React, { useEffect, useRef, useState } from "react"
import { Helmet } from 'react-helmet-async';
import { Container } from "@mui/material";
import ReactQuill from 'react-quill';
import axios from "axios";
import Swal from 'sweetalert2';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { Url, awsFileUrl } from "../url/url";
import 'react-quill/dist/quill.snow.css';
import EditorToolbar, { modules, formats } from "../utils/EditorToolbar";
import "../App.css"
import { productdata } from "../redux/slice/product";
import { maincategorydata } from "../redux/slice/Maincategory";
import { categorydata } from "../redux/slice/category";
import { subcategorydata } from "../redux/slice/subcategory";

const ageGroupOptions = ['0-12 months', '1-2 years', '3+ years', '5+ years', '10+ years'];

const AddProduct = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const mainCategoryAllData = useSelector(store => store.maincategory.data)
    const categoryAllData = useSelector(store => store.category.data)
    const subcategoryAllData = useSelector(store => store.subcategory.data)

    const [keyvalue, setKeyValue] = useState('');
    const [specificationvalue, setSpecificationValue] = useState('');
    const [otherValue, setOtherValue] = useState('');
    const [descriptionValue, setDescriptionValue] = useState('');
    const [loading, setLoading] = useState(false)
    const [formValue, setFormValue] = useState({});
    const [isLimitedEdition, setIsLimitedEdition] = useState(false);

    const [salePriceValue, setSalePriceValue] = useState('');

    const [ageGroupSelectedOptions, setAgeGroupSelectedOptions] = useState([]);
    const [ageGroupError, setAgeGroupError] = useState(false);
    const errorRef = useRef(null);

    const [uploadLoading, setUploadLoading] = useState(false);
    const [progressValue, setProgressValue] = useState(0);
    const [uploadStatus, setUploadStatus] = useState(false);

    const [progressVideoValue, setProgressVideoValue] = useState(0)

    const [multipleFileProgress, setMultipleFileProgress] = useState(0)
    const [totalfiles, setTotalFiles] = useState(0)
    const [totalUpload, setTotalUpload] = useState(0)
    const [multipleFileStatus, setMultipleFileStatus] = useState(false)

    // Category/Subcategory dropdowns sirf selected parent ke hisab se filtered dikhte hain
    const [filteredCategories, setFilteredCategories] = useState([])
    const [filteredSubcategories, setFilteredSubcategories] = useState([])

    useEffect(() => {
        dispatch(maincategorydata())
        dispatch(categorydata())
        dispatch(subcategorydata())
    }, [dispatch])

    const handleAgeGroupChange = (option) => {
        setAgeGroupSelectedOptions((prev) =>
            prev.includes(option)
                ? prev.filter((item) => item !== option)
                : [...prev, option]
        );
    };

    const formHandle = (e) => {
        const name = e.target.name
        const value = e.target.value
        setFormValue({ ...formValue, [name]: value })
    }

    // Main Category select hone par — uski categories filter karo, category/subcategory reset karo
    const mainCategoryHandle = (e) => {
        const mainCatId = e.target.value
        setFormValue({ ...formValue, mainCategory: mainCatId, category: "", subcategory: "" })

        const filtered = categoryAllData.filter(cat => {
            const catMainId = cat.mainCategory?._id || cat.mainCategory
            return catMainId === mainCatId
        })
        setFilteredCategories(filtered)
        setFilteredSubcategories([])
    }

    // Category select hone par — uski subcategories filter karo, subcategory reset karo
    const categoryHandle = (e) => {
        const catId = e.target.value
        setFormValue({ ...formValue, category: catId, subcategory: "" })

        const filtered = subcategoryAllData.filter(sub => {
            const subCatId = sub.category?._id || sub.category
            return subCatId === catId
        })
        setFilteredSubcategories(filtered)
    }

    // MRP ya Discount change hone par Sale Price auto-calculate karo
    const handleMrpOrDiscount = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        const updated = { ...formValue, [name]: value };
        setFormValue(updated);

        const mrp = parseFloat(name === 'mrp' ? value : updated.mrp) || 0;
        const discountRaw = name === 'discount' ? value : updated.discount;
        const discount = parseFloat(discountRaw);

        // Discount field clear kar diya ya empty hai
        if (!discountRaw || discountRaw === '' || Number.isNaN(discount) || discount <= 0) {
            setSalePriceValue('');
            setFormValue({ ...updated, salePrice: '' });
            return;
        }

        if (mrp > 0) {
            // Math.round se integer milega, .00 nahi aayega
            const calculated = String(Math.round(mrp - (mrp * discount) / 100));
            setSalePriceValue(calculated);
            setFormValue({ ...updated, salePrice: calculated });
        }
    };

    const fileHandle = async (e) => {
        const files = e.target.files;
        const name = e.target.name;
        const uploadedFiles = [];
        setTotalFiles(files?.length);
        setTotalUpload(0);
        setMultipleFileProgress(0);
        setMultipleFileStatus(true);

        try {
            await Array.from(files).reduce(async (previousPromise, file, i) => {
                await previousPromise;
                if (file) {
                    const response = await axios.post(`${Url}/api/createPresignedUrl/products`, {
                        fileName: file.name,
                        fileType: file.type
                    });

                    if (response.status === 200) {
                        const { preSignedUrl, key } = response?.data;
                        const responseFileSave = await axios.put(preSignedUrl, file, {
                            onUploadProgress: (progressEvent) => {
                                const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                                setMultipleFileProgress(progress);
                            },
                        });

                        if (responseFileSave.status === 200) {
                            const fileUrl = `${awsFileUrl}/${key}`;
                            setTotalUpload(i + 1);
                            uploadedFiles.push(fileUrl);
                        } else {
                            throw new Error('File upload failed');
                        }
                    }
                }
            }, Promise.resolve());

            setFormValue({ ...formValue, [name]: uploadedFiles });
            setMultipleFileStatus(false);
            setUploadStatus(true);
        } catch (error) {
            console.log(error);
            Swal.fire("Images upload failed, please try again!");
        } finally {
            setMultipleFileStatus(false);
            setProgressValue(0);
        }
    };

    const thumbnailHandle = async (e) => {
        const file = e.target.files[0]
        const name = e.target.name
        setUploadLoading(true)
        setUploadStatus(false)

        try {
            if (file) {
                const response = await axios.post(`${Url}/api/createPresignedUrl/products`, {
                    fileName: file.name,
                    fileType: file.type
                })

                if (response.status === 200) {
                    const { preSignedUrl, key } = response?.data
                    const responseFileSave = await axios.put(preSignedUrl, file, {
                        onUploadProgress: (progressEvent) => {
                            const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                            setProgressValue(progress)
                        },
                    })

                    if (responseFileSave.status === 200) {
                        const fileUrl = `${awsFileUrl}/${key}`
                        setFormValue({ ...formValue, [name]: fileUrl })
                        setUploadStatus(true)
                        setUploadLoading(false)
                        setProgressValue(0)
                    } else {
                        setUploadLoading(false)
                        setProgressValue(0)
                        setUploadStatus(false)
                        Swal.fire("Thumbnail upload failed, please try again!");
                    }
                } else {
                    setUploadLoading(false)
                }
            } else {
                setUploadLoading(false)
            }
        } catch (error) {
            console.log(error);
            setUploadLoading(false)
            setUploadStatus(false)
            Swal.fire("Thumbnail upload failed, please try again!");
        }
    }

    const videoHandle = async (e) => {
        const file = e.target.files[0]
        const name = e.target.name

        try {
            if (file) {
                const response = await axios.post(`${Url}/api/createPresignedUrl/products/video`, {
                    fileName: file.name,
                    fileType: file.type
                })

                if (response.status === 200) {
                    const { preSignedUrl, key } = response?.data
                    const responseFileSave = await axios.put(preSignedUrl, file, {
                        onUploadProgress: (progressEvent) => {
                            const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                            setProgressVideoValue(progress)
                        },
                    })

                    if (responseFileSave.status === 200) {
                        const fileUrl = `${awsFileUrl}/${key}`
                        setFormValue({ ...formValue, [name]: fileUrl })
                        console.log("Video uploaded:", fileUrl);
                    }
                }
            }
        } catch (error) {
            console.log(error);
        }
    }

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setAgeGroupError(false);

        // Validate age group
        if (ageGroupSelectedOptions.length === 0) {
            setAgeGroupError(true);
            errorRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
            setLoading(false);
            return;
        }

        // Validate description aur care instructions
        if (!descriptionValue || !otherValue) {
            Swal.fire("Description and Care Instructions are required!");
            setLoading(false);
            return;
        }

        // Check type
        if (!formValue.type) {
            Swal.fire("Please select Product Type!");
            setLoading(false);
            return;
        }

        // Check main category / category / subcategory chain
        if (!formValue.mainCategory) {
            Swal.fire("Please select Shop (Main Category)!");
            setLoading(false);
            return;
        }
        if (!formValue.category) {
            Swal.fire("Please select Category!");
            setLoading(false);
            return;
        }
        if (!formValue.subcategory) {
            Swal.fire("Please select Sub Category!");
            setLoading(false);
            return;
        }

        // Check sale price
        if (!formValue.salePrice && !salePriceValue) {
            Swal.fire("Please enter Sale Price!");
            setLoading(false);
            return;
        }

        // Thumbnail upload abhi chal raha hai ya complete nahi hua
        if (uploadLoading) {
            Swal.fire("Thumbnail image abhi upload ho raha hai, thoda ruk jao!");
            setLoading(false);
            return;
        }
        if (!formValue.thumbnailImage) {
            Swal.fire("Please upload Thumbnail Image!");
            setLoading(false);
            return;
        }

        // Multiple images upload abhi chal raha hai ya complete nahi hua
        if (multipleFileStatus) {
            Swal.fire("Images abhi upload ho rahi hain, thoda ruk jao!");
            setLoading(false);
            return;
        }
        if (!formValue.images || formValue.images.length === 0) {
            Swal.fire("Please upload Product Images!");
            setLoading(false);
            return;
        }

        const dataValue = {
            ...formValue,
            description: descriptionValue,
            specification: specificationvalue,
            keyFeature: keyvalue,
            otherInfo: otherValue,
            ageGroup: ageGroupSelectedOptions,
            limitedEdition: isLimitedEdition,
            salePrice: salePriceValue || formValue.salePrice,
        };

        try {
            const res = await axios.post(`${Url}/product/add`, dataValue, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            console.log("RESPONSE:", res.data);

            Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Product Added Successfully",
                showConfirmButton: false,
                timer: 1500
            });

            dispatch(productdata());
            navigate("/dashboard/products");

        } catch (error) {
            console.error("ADD PRODUCT ERROR:", error);
            Swal.fire({
                position: "top-end",
                icon: "error",
                title: error?.response?.data?.message || "Something Went Wrong",
                showConfirmButton: false,
                timer: 1500
            });
        } finally {
            setLoading(false);
        }
    };

    // Submit button kab disable rahega — saving ho rahi ho ya koi upload chal raha ho
    const isSubmitDisabled = loading || uploadLoading || multipleFileStatus;

    return (
        <>
            <Helmet>
                <title> Dashboard: Add Product </title>
            </Helmet>

            <Container>
                <div className="mb-4 text-primary">
                    <h2 className="text-capitalize">Add new product</h2>
                </div>
                <div className="p-3 bg-light rounded shadow border">
                    <form action="" onSubmit={e => submit(e)}>
                        <div className="row">

                            {/* Product Name */}
                            <div className="col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">Product Name</p>
                                    <input
                                        type="text"
                                        name="productName"
                                        value={formValue.productName || ""}
                                        onChange={e => formHandle(e)}
                                        className="form-control"
                                        required
                                    />
                                </div>
                            </div>

                            {/* Limited Edition */}
                            <div className="col-lg-6 col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">Limited Edition</p>
                                    <div className="form-check mt-1">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="limitedEdition"
                                            checked={isLimitedEdition}
                                            onChange={(e) => setIsLimitedEdition(e.target.checked)}
                                        />
                                        <span className="form-check-label ms-2">
                                            Mark as Limited Edition
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {/* Short Description */}
                            <div className="col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">Short Description</p>
                                    <textarea
                                        className="form-control"
                                        name="shortDescription"
                                        value={formValue.shortDescription || ""}
                                        onChange={e => formHandle(e)}
                                        rows="3"
                                        required
                                    />
                                </div>
                            </div>

                            {/* Image Alt Tag */}
                            <div className="col-lg-6 col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">Image Alt Tag</p>
                                    <input
                                        type="text"
                                        name="altTag"
                                        value={formValue.altTag || ""}
                                        onChange={e => formHandle(e)}
                                        className="form-control"
                                        required
                                    />
                                </div>
                            </div>

                            {/* Thumbnail Image */}
                            <div className="col-lg-6 col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">Thumbnail Image</p>
                                    <input
                                        type="file"
                                        name="thumbnailImage"
                                        onChange={e => thumbnailHandle(e)}
                                        accept="image/*"
                                        className="form-control"
                                        required
                                    />
                                    <div className="d-flex justify-content-end gap-2 pt-2">
                                        {uploadLoading && progressValue > 0 && (
                                            <progress
                                                className="flex-grow-1"
                                                value={progressValue}
                                                max="100"
                                                style={{ height: "5px" }}
                                            />
                                        )}
                                        {uploadLoading && (
                                            <small className="fs-10 text-secondary">
                                                Uploading... {progressValue}%
                                            </small>
                                        )}
                                        {!uploadLoading && uploadStatus && formValue.thumbnailImage && (
                                            <small className="fs-10 text-success">
                                                ✓ success
                                            </small>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Multiple Images */}
                            <div className="col-lg-6 col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">Images</p>
                                    <input
                                        type="file"
                                        name="images"
                                        multiple
                                        onChange={e => fileHandle(e)}
                                        className="form-control"
                                        required
                                        accept="image/*"
                                    />
                                    {multipleFileStatus && (
                                        <progress
                                            className="w-100"
                                            value={multipleFileProgress}
                                            max="100"
                                            style={{ height: "5px" }}
                                        />
                                    )}
                                    {totalfiles !== 0 && (
                                        <div className="d-flex justify-content-end gap-2 pt-2 align-items-center">
                                            <progress
                                                className="flex-grow-1"
                                                value={(totalUpload / totalfiles) * 100}
                                                max="100"
                                                style={{ height: "5px" }}
                                            />
                                            <small className="fs-10 text-secondary w-max-content">
                                                {totalUpload}/{totalfiles}
                                            </small>
                                            <small className="fs-10 text-success w-max-content">
                                                {((totalUpload / totalfiles) * 100).toFixed(1)}%
                                            </small>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Product Video */}
                            <div className="col-lg-6 col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">
                                        Product Video <span className="fw-normal text-secondary">(optional)</span>
                                    </p>
                                    <input
                                        type="file"
                                        name="video"
                                        accept="video/*"
                                        onChange={e => videoHandle(e)}
                                        className="form-control"
                                    />
                                    <div className="d-flex justify-content-end gap-2 pt-2">
                                        {progressVideoValue > 0 && progressVideoValue < 100 && (
                                            <progress
                                                className="flex-grow-1"
                                                value={progressVideoValue}
                                                max="100"
                                                style={{ height: "5px" }}
                                            />
                                        )}
                                        {progressVideoValue > 0 && (
                                            <small className="fs-10 text-success">
                                                {progressVideoValue < 100 ? `${progressVideoValue}%` : 'success'}
                                            </small>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* MRP */}
                            <div className="col-lg-6 col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">MRP (<i className="fa-solid fa-indian-rupee-sign text-muted fa-sm" />)</p>
                                    <input
                                        type="number"
                                        name="mrp"
                                        value={formValue.mrp || ""}
                                        onChange={handleMrpOrDiscount}
                                        className="form-control"
                                        required
                                        onWheel={(e) => e.target.blur()}
                                    />
                                </div>
                            </div>

                            {/* Discount */}
                            <div className="col-lg-6 col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">
                                        Discount (%) <span className="fw-normal text-secondary">(optional)</span>
                                    </p>
                                    <input
                                        type="number"
                                        name="discount"
                                        value={formValue.discount || ""}
                                        onChange={handleMrpOrDiscount}
                                        className="form-control"
                                        onWheel={(e) => e.target.blur()}
                                    />
                                </div>
                            </div>

                            {/* Sale Price — auto ya manual */}
                            <div className="col-lg-6 col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">
                                        Sale Price (<i className="fa-solid fa-indian-rupee-sign text-muted fa-sm" />)
                                        {salePriceValue && (
                                            <span className="fw-normal text-success ms-2" style={{ fontSize: '12px' }}>
                                                ✓ Auto-calculated
                                            </span>
                                        )}
                                    </p>
                                    <input
                                        type="number"
                                        name="salePrice"
                                        value={salePriceValue || formValue.salePrice || ""}
                                        onChange={(e) => {
                                            setSalePriceValue(e.target.value);
                                            setFormValue({ ...formValue, salePrice: e.target.value });
                                        }}
                                        className="form-control"
                                        required
                                        onWheel={(e) => e.target.blur()}
                                        placeholder="Discount daalne par auto fill hoga"
                                    />
                                </div>
                            </div>

                            {/* Height / Width / Depth / Unit */}
                            <div className="col-lg-6 col-12 mb-2">
                                <div className="row">
                                    <div className="col-lg-3 col-md-6 mb-2">
                                        <div className="form-group">
                                            <p className="mb-0 fw-bold">Height</p>
                                            <input
                                                type="text"
                                                name="height"
                                                value={formValue.height || ""}
                                                onChange={e => formHandle(e)}
                                                className="form-control"
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6 mb-2">
                                        <div className="form-group">
                                            <p className="mb-0 fw-bold">Width</p>
                                            <input
                                                type="text"
                                                name="width"
                                                value={formValue.width || ""}
                                                onChange={e => formHandle(e)}
                                                className="form-control"
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6 mb-2">
                                        <div className="form-group">
                                            <p className="mb-0 fw-bold">Depth</p>
                                            <input
                                                type="text"
                                                name="depth"
                                                value={formValue.depth || ""}
                                                onChange={e => formHandle(e)}
                                                className="form-control"
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6 mb-2">
                                        <div className="form-group">
                                            <p className="mb-0 fw-bold">Unit</p>
                                            <select
                                                name="measurement"
                                                value={formValue.measurement || ""}
                                                onChange={e => formHandle(e)}
                                                className="form-select"
                                                required
                                            >
                                                <option value='' disabled>Choose</option>
                                                <option value="cm">cm</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Total Product */}
                            <div className="col-lg-6 col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">Total Product</p>
                                    <input
                                        type="number"
                                        name="totalProduct"
                                        value={formValue.totalProduct || ""}
                                        onChange={e => formHandle(e)}
                                        className="form-control"
                                        required
                                        onWheel={(e) => e.target.blur()}
                                    />
                                </div>
                            </div>

                            {/* Main Category (Shop) */}
                            <div className="col-lg-4 col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">Shop</p>
                                    <select
                                        name="mainCategory"
                                        value={formValue.mainCategory || ""}
                                        onChange={mainCategoryHandle}
                                        className="form-select"
                                        required
                                    >
                                        <option value='' disabled>Choose Shop</option>
                                        {mainCategoryAllData?.map((m) => (
                                            <option value={m._id} key={m._id} className="text-capitalize">
                                                {m.mainCategory}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            {/* Category */}
                            <div className="col-lg-4 col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">Category</p>
                                    <select
                                        name="category"
                                        value={formValue.category || ""}
                                        onChange={categoryHandle}
                                        className="form-select"
                                        required
                                        disabled={!formValue.mainCategory}
                                    >
                                        <option value='' disabled>Choose Category</option>
                                        {filteredCategories.map((cv) => (
                                            <option value={cv._id} key={cv._id} className="text-capitalize">
                                                {cv.category}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            {/* Sub Category */}
                            <div className="col-lg-4 col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">Sub Category</p>
                                    <select
                                        name="subcategory"
                                        value={formValue.subcategory || ""}
                                        onChange={e => formHandle(e)}
                                        className="form-select"
                                        required
                                        disabled={!formValue.category}
                                    >
                                        <option value='' disabled>Choose</option>
                                        {filteredSubcategories.map((value) => (
                                            <option value={value._id} key={value._id} className="text-capitalize">
                                                {value.subcategory}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            {/* Type */}
                            <div className="col-lg-6 col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">Type</p>
                                    <select
                                        name="type"
                                        value={formValue.type || ""}
                                        onChange={e => formHandle(e)}
                                        className="form-select"
                                        required
                                    >
                                        <option value='' disabled>Choose Type (Optional)</option>
                                        <option value="None">None</option>
                                        <option value="M">M</option>
                                        <option value="L">L</option>
                                        <option value="XL">XL</option>
                                        <option value="XXL">XXL</option>
                                    </select>
                                </div>
                            </div>

                            {/* Batch No */}
                            <div className="col-lg-6 col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">Batch No.</p>
                                    <input
                                        type="text"
                                        name="batch"
                                        value={formValue.batch || ""}
                                        onChange={e => formHandle(e)}
                                        className="form-control"
                                        required
                                    />
                                </div>
                            </div>

                            {/* SKU No */}
                            <div className="col-lg-6 col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">SKU No.</p>
                                    <input
                                        type="text"
                                        name="sku"
                                        value={formValue.sku || ""}
                                        onChange={e => formHandle(e)}
                                        className="form-control"
                                        required
                                    />
                                </div>
                            </div>

                            {/* Replacement */}
                            <div className="col-lg-6 col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">Replacement (days)</p>
                                    <input
                                        type="number"
                                        name="replacement"
                                        value={formValue.replacement || ""}
                                        onChange={e => formHandle(e)}
                                        className="form-control"
                                        required
                                        onWheel={(e) => e.target.blur()}
                                    />
                                </div>
                            </div>

                            {/* Weight */}
                            <div className="col-lg-6 col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">Product Weight (gm)</p>
                                    <input
                                        type="number"
                                        name="weight"
                                        value={formValue.weight || ""}
                                        onChange={e => formHandle(e)}
                                        className="form-control"
                                        required
                                        onWheel={(e) => e.target.blur()}
                                    />
                                </div>
                            </div>

                            {/* Tags */}
                            <div className="col-lg-6 col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">
                                        Choose Tags <span className="fw-normal text-secondary">(optional)</span>
                                    </p>
                                    <select
                                        name="tags"
                                        value={formValue.tags || ""}
                                        onChange={e => formHandle(e)}
                                        className="form-select"
                                    >
                                        <option value="">Choose Any Tag</option>
                                        <option value="top picks">Top Picks</option>
                                        <option value="new arrival">New Arrival</option>
                                    </select>
                                </div>
                            </div>

                            {/* Age Group */}
                            <div className="col-lg-6 col-12 mb-2">
                                <p className="mb-0 fw-bold">Choose Product Age Group</p>
                                {ageGroupError && (
                                    <p ref={errorRef} className="text-danger fw-normal mb-1">
                                        Please select at least one option!
                                    </p>
                                )}
                                {ageGroupOptions.map((option, index) => (
                                    <div key={index} className="form-check">
                                        <input
                                            type="checkbox"
                                            id={option}
                                            checked={ageGroupSelectedOptions.includes(option)}
                                            onChange={() => handleAgeGroupChange(option)}
                                            className="form-check-input"
                                        />
                                        <label htmlFor={option} className="form-check-label">
                                            {option}
                                        </label>
                                    </div>
                                ))}
                            </div>

                            {/* Product Description */}
                            <div className="col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">Product Description</p>
                                    <div className="text-editor bg-white rounded">
                                        <ReactQuill
                                            theme="snow"
                                            value={descriptionValue}
                                            onChange={setDescriptionValue}
                                            placeholder={"Write something awesome..."}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Material */}
                            <div className="col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">key Features</p>
                                    <div className="text-editor bg-white">
                                        <EditorToolbar />
                                        <ReactQuill
                                            theme="snow"
                                            value={keyvalue}
                                            onChange={setKeyValue}
                                            placeholder={"Write something awesome..."}
                                            modules={modules}
                                            formats={formats}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Dimensions */}
                            <div className="col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">Specifications</p>
                                    <div className="text-editor bg-white">
                                        <ReactQuill
                                            theme="snow"
                                            value={specificationvalue}
                                            onChange={setSpecificationValue}
                                            placeholder={"Write something awesome..."}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Care Instructions */}
                            <div className="col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">Other Information</p>
                                    <div className="text-editor bg-white">
                                        <ReactQuill
                                            theme="snow"
                                            name="other_info"
                                            value={otherValue}
                                            onChange={setOtherValue}
                                            placeholder={"Write something awesome..."}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Submit */}
                            <div className="col-12">
                                <div className="form-group text-end">
                                    <button
                                        className="btn btn-primary"
                                        type="submit"
                                        disabled={isSubmitDisabled}
                                    >
                                        {loading
                                            ? "Saving..."
                                            : (uploadLoading || multipleFileStatus)
                                                ? "Uploading..."
                                                : "Post"}
                                    </button>
                                </div>
                            </div>

                        </div>
                    </form>
                </div>
            </Container>
        </>
    )
}

export default AddProduct